//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { CaretDownOutlined, MenuOutlined } from '@ant-design/icons';
import { Alert, Badge, Modal, Snackbar } from '@mui/material';
import WheelModal from 'components/Wheel';
//  -- Components ---------------------
import { Badge as Badges, Card, Col, Drawer, Dropdown, Menu, Row, Tooltip } from 'antd';
import DemoModal from 'components/DemoModal';
import InitialLoading from 'components/InitialLoading';
import LogoIcon from 'components/LogoIcon';

//  -- Features -----------------------
import debounce from 'lodash/debounce';
import { filter, find, get, groupBy, isEmpty, map, sortBy, uniqBy } from 'lodash';
import React, { useCallback, useEffect, useEffectEvent, useLayoutEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
//  -- Thunks -------------------------
import { handleListActivities, handleListCustomAssignment } from 'store/activities/thunks';
import { handleFetchUserData, handleLogout } from 'store/auth/thunks';
import { handleListBookUnits, handleListGoogleCourse } from "store/booksUnits/thunks";
import { handleListQuizzes } from 'store/quizzes/thunks';
import { handleGetServertime } from 'store/servertime/thunks';
import { handleListClassUsers } from 'store/userClasses/thunks';
import { useDemoStatus, useProfilePicturePicker, useUserProfileConfig, useUserRole } from "store/users/selectors";
import styled from 'styled-components';
//  -- Constants ----------------------
// import OneWayDebateModal from './OneWayDebateModal';
import { ExitToApp, Group, Update, VpnKey, LockReset, School, Class, Announcement, Security, Logout, Report } from '@mui/icons-material';
import ActiveStudentStatus, { MessageAlertViewer } from 'components/ActiveStudentStatus';
import AssignableSharePopup from 'components/AssignableSharePopup';
import AssignmentReviewByNotify from 'components/AssignmentReviewByNotify';
import CheckListModal from 'components/CheckListModal';
import AdminMenu from "components/HomeMenu/admin";
import BottomIcons from 'components/HomeMenu/BottomIcons';
import DistrictAdminMenu from "components/HomeMenu/district_admin_new";
import { useOrientation } from 'components/hooks';
import usecheckIFrame from 'components/hooks/usecheckIFrame';
import useDeviceActiveState from 'components/hooks/useDeviceActiveState';
import { usePermissionUpdateNotification } from 'components/hooks/usePermissionUpdateNotification';
import { useAdminActivityLogger } from 'components/hooks/useAdminActivityLogger';
import ModalMenu from 'components/Modals';
import JoinGameNotificationModal from "components/OneGame/JoinGameNotificationModal";
import OneGameJoinModalButton from 'components/OneGame/OneGameJoinModalButton';
import OPenOneGame from "components/OneGame/OpenOneGame";
import { ProfileAvatarPicker } from 'components/ProfileImagePicker';
import SearchComponent from 'components/Search';
import TrafficModal from 'modules/widget/TrafficModal';
import WheelCheckList from 'components/WheelCheckList';
import NoiseMeter from 'modules/widget/NoiseMeter';
import WheelWidget from 'modules/widget/wheelWidget';
import WidgetsExpression from 'modules/widget/WidgetsExpression';
import WidgetsGroup from 'modules/widget/WidgetsGroup';
import WidgetsStation from 'modules/widget/WidgetsStation';
import WidgetsText from 'modules/widget/WidgetsText';
import WidgetsTimer from 'modules/widget/WidgetsTimer';
import WidgetsReminder from 'modules/widget/WidgetsReminder';
import ReminderStudentPopups from 'modules/widget/reminder/ReminderStudentPopups';
import WidgetsClock from 'components/widgetsClock';
import WidgetsImages from 'components/WidgetsImages';
import WidgetsStory from 'components/WidgetsStory';
import { useIsMobileDevice, useMobileDetect, useTabletDetection } from 'containers/chat/hooks';
import Chat from "containers/chat/popup";
import HeaderChatNavButton from 'containers/chat/HeaderChatNavButton';
import { useFirebase } from 'containers/FirebaseContext';
import {
    collection,
    onSnapshot,
    orderBy,
    query,
    where
} from 'firebase/firestore';
import BingoModal from 'modules/bingoModule';

const Lottie = React.lazy(() => import('lottie-react'));
import SlideWidgetComponent from 'modules/slideWidgetModule/slideWidgetComponent';
import queryString from 'query-string';
import { handleListAllBooks, handleListAllowedBooks, handleListBookOrder, handleListBooksCover } from 'store/books/thunks';
import { handleListChatInfo } from "store/chat/thunks";
import { useClassActivities } from 'store/classActivities/selectors';
import { handleListClassActivities, handleListActivityOrQuizData } from 'store/classActivities/thunks';
import { handleListAllTeacherFromClass } from 'store/classes/thunks';
import { useClassQuizzes } from 'store/classQuizzes/selectors';
import { handleListClassQuizzes } from 'store/classQuizzes/thunks';
import { useExams } from 'store/exams/selectors';
import { handleListAllExamData } from 'store/exams/thunks';
import { handleInvokeFeedbackForm } from 'store/feedback/thunks';
import { handleGetClassActiveGameSession } from 'store/game_session/thunks';
import { openLoginInNewWindow } from 'store/keystore/thunks';
import { useNotifications } from 'store/notification/selectors';
import { handleGamePopupNotify } from 'store/notification/thunks';
import { useOneGameModal, usePlayModal } from 'store/one_game/selectors';
import { useCurrentOrgPermission } from "store/organizations/selectors";
import { handleGetVocabPermissionForStudent, handleListGetSchool } from 'store/organizations/thunks';
import { useResources } from 'store/resources/selectors';
import { handleListResourcesAndVideo } from "store/resources/thunks";
import { handleGetRubric } from 'store/rubric/thunks';
import { useSchoologyGradeCategory } from 'store/schoologyauth/selectors';
import { handleListStory, handleListStoryStandard } from 'store/story/thunks';
import { handleListStoryAiConfig } from 'store/StoryAiCofig/thunks';
import { handleListClassSubmissions , handleListSubmissionsByAssignmentAndClass } from 'store/submissions/thunks';
import { updateUI } from 'store/UI/actions';
import { useTimmerRunning } from 'store/timmer/selectors';
import { handleListWidgets } from 'store/widgets/thunks';
import { debatePoster, IGameHome7, profileArrow, userImg, SoyHistoriasNew } from "utils/assets/images";
import { getAvatar, NOTIFICATIONICONS } from 'utils/assets/images/lootie';
import customNotifySvg from "../utils/assets/images/custom-notify.svg";
import birdIconSvg from "../utils/assets/images/birdIcon.svg";
import { KEY_FOR_REMOVE } from "utils/config/reference";
import COLOR from 'utils/constants/color';
import { useFullScreen } from 'utils/context/FullScreenProvider';
import { imageFetch, imageFetchFromPodcast, isVideo , getAssignmentNavigationUrl } from 'utils/lib/ebookHelper';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { useCollectionWidgets } from 'utils/methods/firebaseWidgets';
import AlertViewModal from './AlertViewModal';
import BooksNotFoundRefreshModal from './BooksNotFoundRefreshModal';
import WrapperChatSocket from './WrapperChatSocket';
import FeedbackForm from './FeedbackForm';
import IdeaModal from './ideaModal';
// import PreviousFDWidgetComponent from 'modules/PreviousFDWidgetModul/previousFDWidgetComponent';
import * as Sentry from '@sentry/react';
import SentryWrap from 'components/Sentry';
import TopDrawer from 'components/classDrawerComponent';
import TopDrawers from 'components/classDrawerComponent1';
import useFetchWrapper from 'components/hooks/fetchAllContent/useFetchWrapper';
import PreviousFDWidgets from 'components/previousFeedback';
import { ShareAssignmentWidget } from 'modules/shareAssignment';
import ShareNotificationWithStudents from 'components/StoryWithAi/shareNotificationWithStudents';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import config from 'config';
import StudentGroupGradeBook from 'modules/studentGroup';
import { useLocation } from "react-router-dom";
import { useCurrentGameSession } from 'store/game_session/selectors';
import { useClassGameActivity } from 'store/one_game/selectors';
import { handleListClassGameActivity } from 'store/one_game/thunks';
import { disableBodyScroll } from 'utils/methods/math';
import { checkAuth } from 'utils/lib/auth';
import { useAllBook, useBookOrder } from 'store/books/selectors';
import DebateModal from 'modules/DebateComponent';
import EbookTimeModal from 'components/UI/Prompt/ebookTimeModal';
import { useCurrentClassBook } from 'store/classes/selectors';
import { getCoverForAssignment } from 'utils/methods/functions';
import useQuotesData from 'components/hooks/useQuotesData';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import SpinLoader from 'components/Loader/SpinLoader';
import useGetRedirectUrlForNotification from 'containers/hooks/useGetRedirectBookNotification';
import useBookCollection from 'components/hooks/books/useBookCollection';
import { handleListWorkSheet } from 'store/worksheet/thunks';
import { handleListInstructionByUser, handleListInstructionByClass } from 'store/instructions/thunks';
import { useShareNotification } from 'utils/methods/firebaseShareAssignment';
import { useStandardExams } from 'store/standardexams';
import TeacherPermission from 'modules/teacherPermission';
import { getParentStudents } from 'store/email/thunks';
import { useUI } from 'store/UI/selectors';
import useActiveStudentofParent from 'components/hooks/parent/activeStudentofParent';
import useBadWords from 'components/hooks/words/badWords';
import { useClassBooks } from 'components/hooks/books/useClassBooks';
import { handleGetUserPermissions } from 'store/permissions/thunks';
import Loading from 'components/Loading';
import ViewUserInfoModal from 'components/ViewUserInfoModal';
import { SYSTEM_NOTIFICATION_TYPES } from 'utils/constants/enum';
import useFetchUnseenNotifications from 'components/hooks/notification/useFetchUnseenNotifications';
import CommonWrapper from 'components/UI/commonWrapper';
import { checkLatestDeploymentRefresh } from 'utils/methods/checkLatestDeploymentRefresh';
import { useNotificationPageCover } from 'components/hooks/pageCover/notificationPageCover';

const MobileMenu = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-weight: 600;
    margin-left: 12px;
    line-height: initial;

    @media (min-width: 1100px) {
        display: none !important;
    }
`;

const ButtonLink = styled.button`
    align-items: center;
    background-color: transparent;
    border: none;
    /* color: ${COLOR.black200}; */
    cursor: pointer;
    display: inline-flex;
    flex-direction: row;
    font-size: 12px;
    outline: none;
    padding: 4px 7px;
    color: white;
    text-transform: uppercase;

    &:hover {
        background-color: ${COLOR.green300};
        color: ${COLOR.white}
    }
    @media (min-width:992px) and (max-width:1168px) {
        font-size: 20px !important;
        padding: 4px 6px !important;
    }
       @media (max-width: 991px) {
            font-size:20px;
       }
    // @media (min-width:993px) and (max-width: 1370px) {
    //     font-size: ${p => p.to !== "desktop" && "25px"  };
    // }
    @media (min-width: 820px) and  (max-width: 1100px) {
        font-size: ${p => p.laptop && "8px !important"  };
    }
    @media  (max-width: 1292px) {
        font-size: ${p => p.to === "desktop" && "9px !important"  };
    }
    @media (max-width: 568px) {
        padding: 4px 2px;
        // font-size: 20px;
        &:hover {
            font-size: 14px;
            background-color: ${COLOR.green300};
            color: ${COLOR.white}
        }
    }
    @media (max-width: 320px) {
        padding: 4px 1px;
        font-size: 10px;
    }
`;
const ButtonLinkLogo = styled.button`
    align-items: center;
    background-color: transparent;
    border: none;
    /* color: ${COLOR.black200}; */
    cursor: pointer;
    display: inline-flex;
    flex-direction: row;
    font-size: 14px;
    outline: none;
    padding: 2px 8px;
    color: white;
    margin: 0px 0px 2px;
    @media (max-width: 568px) {
        padding: 0px 2px;
        font-size: 12px;
        &:hover {
 
        }
    }
    @media (max-width: 320px) {
        padding: 4px 1px;
        font-size: 10px;
    }
`;

const CenterContainer = styled.div`
    height: 100%;
    min-height: 100vh;
    padding: 64px 0px;
    width: 100%;

    @media (min-width: 800px) {
        align-items: center;
        display: flex;
        justify-content: center;
        padding: 0px;
    }
`;

const ChildContainer = styled.div`
    height: 110%;
    width: 100%;
`;


const Container = styled.div`
    height: 100%;
    width: 100%;
`;

const CustomBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    text-align: left;
    margin-right:5px;
`;

const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 700;
    outline: none;
    padding: 4px;
    text-align: left;
    width: 100%;
`;

const InnerContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: space-between;
    width: 100%;
`;


const MaxWidthContainer = styled.div`
    height: ${p => p.height || 'calc(100% - 55px)'};
    margin: 0px auto;
    // max-width: 1360px; 
    padding: ${props => (props.val ? '0px 0px' : '0px 24px')};
    width: 100%;

       @media (min-width:820px) and (max-width:1100px) {
         padding: ${props => (props.laptop && '0px 5px')};
    }
    @media (min-width:992px) and (max-width:1168px) {
         padding: ${props => (props.val && '0px 0px')};
    }


     @media (max-width: 1300px) {
    padding: ${props => {
        if (props.informateBook) return '0px 30px !important';
        return '';
}};
      @media (max-width: 600px) {
        padding: ${props => {
            if (props.whatsNew || props.isStrategies || props.isGraphicOrganizers) {
            return '0px !important';
            }
            return '0px 16px !important';
        }};
    }

`;


const MobileBar = styled.div`
    /* border-bottom: 1px solid ${COLOR.black800}; */
    display: block;
    height: 60px;
    padding: 8px 16px;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    @media (min-width: 1100px) {
        display: none !important;
    }
    @media (min-width: 772px) {
       background-color:black;
    }
    @media (max-width: 568px) {
        padding: 8px 10px;
    }
`;

const Navigation = styled.ul`
    align-items: center;
    display: flex;
    flex-direction: row;
    height: 100%;
    list-style-type: none;
    margin: 0px;
    padding: 0px;
`;

const NavigationItem = styled.li`
    align-items: center;
    display: ${p => p.desktop ? 'none' : 'flex'};
    flex-direction: row;
    height: 100%;
    margin-right: 8px;

    &:first-child {
        margin-left: 0px;
        margin-right: 10px;
    }
    @media (min-width:992px) and (max-width:1168px) {
        margin-right: 0px !important;
    }

       @media (min-width: 900px) {
            // display: ${p=> p.laptop  ? "flex" : "none"};
            margin-right: ${p => p.laptop ? "4px" : ""};
        }

//     @media (min-width: 809px) and (max-width: 1200px) and 
//        (min-height: 700px) and (max-height: 1370px) and 
//        (orientation: landscape) {
//     display: none!important;
// }

// @media only screen and (min-device-width: 768px) and (max-device-width: 1275px) 
//        and (orientation: landscape) {
//     display: none!important;
// }
            
    @media (min-width: 1100px) {
        display: flex;
        margin-right: 4px;
    }
    @media (max-width: 568px){
        margin-right: 6px;
        margin-left: 6px;
    }
    @media (max-width: 320px){
        margin-right: 1px;
    }
`;

const NavigationItemLogo = styled.li`
    align-items: center;
    flex-direction: row;
    height: 100%;
    margin-top: 0px;
    @media (max-width: 568px){
        margin-right: 6px;
        margin-top: 0px;
    }
`;



const RowContainer = styled.div`
    border-left: ${p => p.border && `1px solid ${COLOR.black700}`};
    margin-left: 10px;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (max-width: 765px) {
        align-items: flex-end;
        max-width: 100%;
    }

    @media (min-width: 765px) {
        flex-direction: row;
        align-items: center;
    }
`;

const RowItem = styled.div`
  margin-right: 8px;
  @media (max-width: 1362px) {
    margin-right: 3px;
  }
  @media (max-width: 1099px) {
     margin-right: 12px;
  }
  @media (max-width: 1099px) {
     margin-right: 8px;
  }
`;




const NavWrap = styled.div`
    background-color: ${COLOR.white};
    box-shadow: 0 3px 6px rgba(0,0,0,0.1), 0 3px 6px rgba(0,0,0,0.17);
    // overflow-x: hidden;
    // overflow-y: hidden;
`;

const TopBar = styled.div`
    /* border-bottom: 1px solid ${COLOR.black800}; */
    height: 40px;
    position: relative;
    width: 100%;

    @media (min-width: 768px) {
        height: 105px;

    }
    @media (max-width: 992px) {
        height: 90px;
        border-bottom:0px
    }
`;

const UserContainer = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
`;

const UserDetails = styled.div`
    display: none;
    flex-direction: column;
    justify-content: flex-end;
    margin-right: 8px;

    @media (min-width: 765px) {
        display: flex !important;
    }
`;
const UserDetailsMob = styled.div`
    display: none;
    flex-direction: column;
    justify-content: flex-end;
    margin-right: 8px;

    // @media (max-width: 768px) {
    //     display: flex;
    // }

    // @media (max-width: 820px) {
    //     display: ${p=>  p.laptop ? "none !important": "flex"};
    // }
    //  @media (max-width: 820px) {
    //     display: ${p=>  !p.laptop ? "flex !important": "none"};
    // }
`;
const UserDetailsMobs = styled.div`
    display: none;
    flex-direction: column;
    justify-content: flex-end;
    margin-right: 8px;
    flex-shrink: 0;

    @media (max-width: 765px) {
        display: flex !important;
    }

    @media (min-width: 765px) {
        display: none !important;
    }
`;
const UserName = styled.span`
color: white;
    display: block;
    font-size: 13px;
    font-weight: 600;
    line-height: 14px;
    margin-bottom: 0px;
`;
const UserDistrict = styled.span`
    color: white;
    font-size: 10px;
    font-weight: 500;
    line-height: 11px;
    text-align: center;
    margin-top: 5px;
`;


const HyperLinkContainer = styled.div`
    width:100%;
    background-image: linear-gradient(to right, rgb(189,38,95), rgb(217,87,61));
    color: white;
    z-index: 1;
    white-space: pre-line;
    padding: 10px;
    min-height: 50px;
`;
const HyperLinksInner = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: transparent;
    border:1px solid #fff;
    min-height: 50px;
    color: #fff;
    padding: 15px;
`;
const LinksItem = styled.a`
    color: #fff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    transition: color 0.3s;
    &:hover {
        color: ${COLOR.white};
    }
    &:before {
        display: inline-block;
        content: '';
        -webkit-border-radius: 0.375rem;
        border-radius: 0.375rem;
        height: 0.75rem;
        width: 0.75rem;
        margin-right: 0.5rem;
        background-color: #fff;
    }
`;
const NotificationContainer = styled.div`
   min-width:380px;
   min-height:50px;
   padding:10px 15px 20px 15px;
   overflow-y:scroll;
   max-width:391px;
    @media (max-width: 600px) {
     min-width:100%;
   }
`;
const NotificationHeader = styled.div`
    display:flex;
    align-item:center;
    justify-content:space-between;
    border-bottom:1px dashed #e7eaef;
`;
const TextHeader = styled.p`
    font-size:17px;
    font-weight:600;
    color:rgb(28, 49, 115);
    margin-bottom:6px;
`;
const TextReadAll = styled.p`
    font-size:15px;
    font-weight:600;
    color:rgb(28, 49, 115);
    margin-bottom:6px;
`;
const NotificationBody = styled.div`
   padding:16px 0px;
`;
const NoNotificationText = styled.p`
   font-size:14px;
   color:gray;
   margin:30px 0px;
   text-align:center;
`;
const ViewAllBtn = styled.button`
    background-color: rgb(28, 49, 115);
    color:white;
    border: none;
    border-radius: 3px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    cursor: pointer;
    height: 40px;
    outline: none;
    transition: all 300ms ease;
    width: 100%;
    &:hover {
        box-shadow: 0 10px 15px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22);
        opacity: 0.7;
    }
`;
const ReadAllBtn = styled.button`
    background-color: white;
    border: none;
    outline: none;
    cursor: pointer;
`;
const NotificationSection = styled.div`
  padding-left: 10px;
  max-width: calc(100% - 60px);
`;
const TextTitle = styled.div`
  font-size: 14px;
  color: #000000;
  font-weight: 600;
  text-align: left;
  width: 86%;
`;
const TextDate = styled.div`
  font-size: 12px;
  color: #000000;
  font-weight: 500;
  text-align: left;
`;
const TextDateTitle = styled.div`
  font-size: 12px;
  color: #000000;
  font-weight: 600;
  text-align: left;
`;

const Image = styled.img`
  height: 50px;
  width: 40px
`;

const NotificationsMainSection = styled.div`
  display: flex;
  flex-direction: row;
  align-item: center;
`;

const MenuIconsWrapper = styled.div`
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
`;

const StyledDrawer = styled(Drawer)`
  padding-bottom: 50px;
  @media screen and (max-width: 767px) and (orientation: landscape) {
    .ant-drawer-content-wrapper {
      height: 80vh !important;
    }
  }
`;

const TEACHER_HOME_PATHNAMES = new Set([
    '/teacher/home',
    '/student/home',
    '/parents-student-home',
]);

const Wrapper = ({
    currentOrg,
    currentUser,
    children,
    userClasses,
    booksAllList,
    currentClass,
}) => {
    const { pageCover } = useNotificationPageCover();
    const AllstandardExam = useStandardExams();
    const exams = useExams();
    const showAlert = useAlert();
    const {redirectToBook} = useGetRedirectUrlForNotification();
    const resourcess = useResources();
    const { currentGameSession } = useCurrentGameSession();
    const classActivities = useClassActivities();
    const { class_game_activity } = useClassGameActivity()
    const classQuizzes = useClassQuizzes()
    const allNotifications = useNotifications();
    const { firebaseUser } = useFirebase();
    const filterByClass = useMemo(() => 
        get(currentUser, 'role', '') == 'teacher' ?
        filter(allNotifications, obj => obj.classId == get(currentClass, 'id', '') && obj.userId !== get(currentUser, "id")) :
        filter(allNotifications, (obj) => {
            const classes = get(obj?.data, 'classes', [])?.find((cls) => cls.id === get(currentClass, 'id', ''));
            const classConfigExist = Array.isArray(classes?.users) ? classes?.users.some((user) => user === get(currentUser, 'id', '')) : true;
            return (obj.createdBy == get(currentClass, 'id', '') || obj.createdBy == get(currentUser, 'id', '')) && obj.userId !== get(currentUser, "id") && classConfigExist && obj?.classId === get(currentClass, 'id', '')
        }),
        [allNotifications, currentUser, currentClass]);
    const isCurrentStudentActive = useMemo(() => {
        if (get(currentUser, 'role') === 'teacher') {
            return true;
        }
        const classInfo = find(userClasses, ['id', currentClass?.id]);
        const isClassActive = typeof classInfo?.userclass?.active === 'boolean' ? classInfo.userclass.active : true;
        const isAccountActive = get(currentUser, 'active') !== false;
        return isClassActive && isAccountActive;
    }, [currentUser, userClasses, currentClass?.id]);

    const isExamHidden = useCallback((chapter) => {
        const fetchExams = exams?.find((entry) => entry.exams.flatMap((exam) => `${exam.bookId}`).includes(`${chapter}`));
        if (!fetchExams) {
            return false;
        }
        const classInfo = find(userClasses, ['id', currentClass?.id]);
        const isHidden = classInfo?.config?.meta_data || {};
        const examLevel = fetchExams?.exam_school || '';
        if (isHidden.highSchool && examLevel === 'high') {
            return true;
        }
        if (isHidden.middleSchool && examLevel === 'middle') {
            return true;
        }
        return false;
    }, [exams, userClasses, currentClass?.id]);

    const { createCollectionWidgets } = useCollectionWidgets();
    const { updateCollectionNotification, updateNotificationsFetched, markAllAsRead, onMissingNotification } = useCollectionNotification();
    const { updateShareNotification, updateShareNotificationsBatch } = useShareNotification();
    const allAssignment = [...classActivities, ...classQuizzes, ...class_game_activity];
    const orgPermissions = useCurrentOrgPermission()
    const demoStatus = useDemoStatus()
    const dispatch = useDispatch();
    const allBooks = useAllBook();
    const location = useLocation();
  	const navigate = useNavigate();
    const isTeacherHome = useMemo(
        () => TEACHER_HOME_PATHNAMES.has(location.pathname),
        [location.pathname],
    );
    usePermissionUpdateNotification();
    useAdminActivityLogger();
    
    const [modalOpen, toggleModal] = useState(false);
    const [modalOpenVideosDemo, toggleModalVideosDemo] = useState(false);
    const [permissionsModalOpen, setPermissionsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [mounted, setMounted] = useState(false);
    const [open, setOpen] = React.useState(false);
    const viewInfoModalRef = React.useRef(null);
    const { firestore } = useFirebase();
    const { profile_config } = useUserProfileConfig()
    const { showProfilePhotoViewer } = useProfilePicturePicker()
    const [timmerRunning, ,] = useTimmerRunning()
    const [popupMessage, setPopupMessage] = React.useState('');
    const [notificationCount, setNotificationCount] = useState(0);
    const [reviewData, setReviewData] = useState();
    const [assignmentDrawer, toggleAssignmentDrawer] = useState(false);
    const [isnotification, setIsnotification] = useState(false);
    const [isnotificationMob, setIsnotificationMob] = useState(false);
    const [activeStatus, setActiveStatus] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState()
    const { oneGameModal  } = useOneGameModal()
    const [sharableWidget, setSharableWidget] = useState([])
    const [sharableUserWidget, setSharableUserWidget] = useState([])
    const [openMenuClass, setOpenMenuClass] = useState(false);
    const { currentFullScreen, FullScreenMode, ExitFullScreenMode } = useFullScreen();
    const [loaderForFetchSessionData,setLoaderForFetchSessionData] = useState(false);
    const bookOrder = useBookOrder()
    const [showTimerModal, setShowTimerModal] = useState(false);
    const [pendingChapter, setPendingChapter] = useState(null);
    const [loadingQuestions, setloadingQuestions] = useState(false);
    const [trafficWidgetData,setTrafficWidgetData] = useState([]);
    const allowed_books = useCurrentClassBook();
    useQuotesData();
    useBadWords();
    const { is_student, is_teacher } = useUserRole();
    
    const { updatePopUpAtOnce } = usePopUpAtOnce();
    
    const findEngageData = (assignmentData) => {
        try {
            if (!assignmentData) return null;
            const currentEngage = assignmentData?.config_assignment?.engage_id;
            if (currentEngage) {
                const sortById = sortBy(allBooks, 'id');
                const book = find(sortById, { id: assignmentData?.chapter });
                if (book?.engage) {
                    const engage = find(book.engage, { id: currentEngage });
                    return engage;
                }
            }
            return null;
        } catch (error) {
            console.log(error, "error");
            return null;
        }
    };
    
    const getEngageCoverImage = (assignmentData) => {
        if (!assignmentData) {
            return null;
        }
        const is_engage = assignmentData?.config_assignment?.isFrom === 'engagement';
        if (is_engage) {
            const chapterId = assignmentData?.chapter;
            if (!chapterId) {
                return null;
            }
            
            const sortById = sortBy(allBooks, 'id');
            const book = find(sortById, (b) => String(b?.id) === String(chapterId));
            if (!book?.engage || !Array.isArray(book.engage)) {
                return null;
            }
            
            const engageId = assignmentData?.config_assignment?.engage_id;
            if (!engageId) {
                return null;
            }
            
            const engage = find(book.engage, (e) => String(e?.id) === String(engageId));
            if (!engage?.imageData || !Array.isArray(engage.imageData) || engage.imageData.length === 0) {
                return null;
            }
            
            const sequenceOrder = assignmentData?.config_assignment?.sequence_order;
            if (!sequenceOrder) {
                return null;
            }
            
            const findImageData = find(engage.imageData, (img) => 
                String(img?.id) === String(sequenceOrder)
            );
            return findImageData?.resource || null;
        }
        return null;
    };

    const modalSrc = (activeAssignment, findData) => {
        if (activeAssignment?.type === 'share_notification') {
            const shareData = activeAssignment?.shareNotificationData || activeAssignment;
            const assignmentType = shareData?.data?.assignmentType || shareData?.assignmentType || '';
            const storyInstruction = shareData?.data?.storyInstruction || shareData?.storyInstruction || '';
            
            if (assignmentType === 'story') {
                return SoyHistoriasNew;
            }
            
            if (storyInstruction) {
                const storyData = {
                    data: {
                        storyInstruction: storyInstruction,
                        assignmentType: 'story'
                    }
                };
                const cover_img_ext = getCoverForAssignment(storyData);
                if (cover_img_ext) return cover_img_ext;
            }
        }
        
        let assignmentData = null;
        if (findData?.data?.config_assignment) {
            assignmentData = findData.data;
        } else if (activeAssignment?.data?.config_assignment) {
            assignmentData = activeAssignment.data;
        } else {
            assignmentData = findData?.data || activeAssignment?.data;
        }
        
        const coverImage = pageCover(assignmentData,activeAssignment);
        if(coverImage) return coverImage;
        
        const item = activeAssignment?.data?.game_data || {};
        const type = activeAssignment?.data?.assignmentType || '';
        const image_url = item && item?.media_urls?.image ? item?.media_urls?.image : IGameHome7;
        const cover_img_ext = getCoverForAssignment(findData)
        if (type === "debate") return debatePoster;
        if (cover_img_ext) return cover_img_ext;
        if (isVideo(get(activeAssignment, "data.chapter"), resourcess)) {
            return imageFetchFromPodcast(get(activeAssignment, "data.chapter"), resourcess);
        } else if (get(activeAssignment, "type") === 'play_game_notification') {
            return image_url;
        }
        else {
            return imageFetch(
                booksAllList,
                get(activeAssignment, "data.chapter"),
                get(activeAssignment, "data.page")
            );
        }
    }
    const isMobile = useMobileDetect();
    const [openBottom, setOpenBottom] = useState(false);
    const [openMenuBook, setOpenMenuBook] = useState(false);
    // const [ideasModal, setIdeasModal] = useState(false);
    const [wheelsModal, setWheelsModal] = useState(false);
    const [debatesModal, setDebatesModal] = useState(false);
    const [oneGameModalVisible, setOneGameModalVisible] = useState(false);
    const [bingoModals, setBingoModals] = useState(false);
    const [notificationsData, setNotificationsData] = useState([])
    const [shareNotificationsData, setShareNotificationsData] = useState([])
    const [ideasModal, setIdeasModal] = useState(false);
    const tab = useTabletDetection();
    const mobile = useIsMobileDevice();
    const laptop = !tab && !mobile;
    const isFrame = usecheckIFrame();
    // const location = useLocation();
    // const navigate = useNavigate();
    const fullName = `${currentUser?.firstName} ${currentUser?.lastName}`;
    const isNameLong = fullName.length > 15;
    const isCanvasUser  = !!get(currentUser,"canvas_id")
    const [, , , listAllclassSchoologyGradeCategory] = useSchoologyGradeCategory()
    const deteactRotate = useOrientation();
    const is_placement_admin_user = useMemo(()=>currentUser?.role==='placement_admin',[currentUser]);
    const {fetchContent} = useFetchWrapper();
    const { openPlayerModal, playGameModal } = usePlayModal()
    const search = queryString.parse(location.search);
    const {hiddenBookGroupBookId = [], hiddenBookId = []} = useBookCollection();
    const { parentStudents = [] } = useUI();
    const { activeStudentParent } = useActiveStudentofParent();
    const { loading: loadingClassBooks , fetchClassBooks  , clearLoadingState } = useClassBooks()
    const [markAllDoneNotificationLoading,setMarkAllDoneNotificationLoading] = useState(false);
    useEffect(() => {
            setIsnotificationMob(false);
            setIsnotification(false)

    }, [deteactRotate])
    useEffect(() => {
        if (currentClass && currentClass.id) {
            fetchClassBooks()
        }
    }, [currentClass])
    
    useEffect(() => {
        if (!firebaseUser || (firebaseUser && Object.keys(firebaseUser).length === 0)) return;
        const unsubscribe = listenToNotificationData(get(currentClass, 'id', ''));
        const unsubscribeShare = listenToShareNotificationData();
        return () => {
            unsubscribe();
            if (unsubscribeShare && typeof unsubscribeShare === 'function') {
                unsubscribeShare();
            }
        };
    }, [firestore, currentClass?.id, currentUser?.id, firebaseUser])

    const listenToNotificationData = (classID) => {
        if (!classID || !currentUser) {
            return () => {};
        }
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            return () => {};
        }
        const collectionRef = collection(firestore, "notifications");
        const q = query(collectionRef,
            where("classId", "==", classID),
            where("receiversId", "array-contains", currentUser.id),
            where("senderId", "!=", currentUser.id),
            orderBy("modified", "desc")
        );
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const notifications = [];
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                const originalId = data.id;
                notifications.push({ 
                    ...data, 
                    id: originalId || doc.id,
                    firebaseDocId: doc.id
                });
            });
            const filterBySender = filter(notifications, (notification) => notification.receiversId?.includes(currentUser.id));
            setNotificationsData(filterBySender);
        }, (error) => {
            if (error && error.code === 'failed-precondition') {
                console.warn("Firestore listener offline (notifications), running in offline mode:", error);
                return;
            }
            console.error("Error listening to session changes:", error);
        });
        return unsubscribe;
    };

    const listenToShareNotificationData = () => {
        if (!firestore || !currentUser?.id) {
            return () => {};
        }
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            return () => {};
        }
        const collectionRef = collection(firestore, "share_notifications");
        const q = query(collectionRef,
            where("createdBy", "!=", currentUser.id),
            where("notification_list", "array-contains", currentUser.id)
        );
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const shareNotifications = [];
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                const userSeen = data.userSeen || [];
                const timestamp = data.shared_time || data.modified;              
                const formattedNotification = {
                    id: doc.id,
                    displayName: data.displayName || data.display_name || 'Shared Content',
                    message: data.message || '',
                    modified: timestamp,
                    shared_time: data.shared_time || timestamp,
                    data: {
                        chapter: data.chapter || data.bookId,
                        page: data.page || data.pageId,
                        id: data.id,
                        assignmentType: data.data?.assignmentType || data.assignmentType || 'worksheet',
                        storyInstruction: data.data?.storyInstruction || data.storyInstruction || '',
                        url: data.url
                    },
                    type: 'share_notification',
                    userSeen: userSeen,
                    senderId: data.createdBy,
                    receiversId: data.notification_list || [],
                    shareNotificationData: data
                };               
                shareNotifications.push(formattedNotification);
            });
            setShareNotificationsData(shareNotifications);
        }, (error) => {
            if (error && error.code === 'failed-precondition') {
                console.warn("Firestore listener offline (share notifications), running in offline mode:", error);
                return;
            }
            console.error("Error listening to share notifications:", error);
        });
        return unsubscribe;
    };

    const filterNotificationData = useMemo(() => {
      const allNotifications = [...notificationsData, ...shareNotificationsData];
      if (allNotifications?.length > 0) {
        const sorted = allNotifications.sort((a, b) => {
          const timestampA = a.modified || a.shared_time || 0;
          const timestampB = b.modified || b.shared_time || 0;
          const dateA = new Date(timestampA);
          const dateB = new Date(timestampB);
          const isValidA = !isNaN(dateA.getTime());
          const isValidB = !isNaN(dateB.getTime());
          
          if (!isValidA && !isValidB) {
            const aIsNew = a.userSeen ? !a.userSeen.includes(currentUser?.id) : !a.seen;
            const bIsNew = b.userSeen ? !b.userSeen.includes(currentUser?.id) : !b.seen;
            if (aIsNew && !bIsNew) return -1;
            if (!aIsNew && bIsNew) return 1;
            return (b.id || '').localeCompare(a.id || '');
          }
          if (!isValidA) return 1;
          if (!isValidB) return -1;
          
          const timeDiff = dateB - dateA;
          if (timeDiff === 0) {
            const aIsNew = a.userSeen ? !a.userSeen.includes(currentUser?.id) : !a.seen;
            const bIsNew = b.userSeen ? !b.userSeen.includes(currentUser?.id) : !b.seen;
            if (aIsNew && !bIsNew) return -1;
            if (!aIsNew && bIsNew) return 1;
            return (b.id || '').localeCompare(a.id || '');
          }
          
          return timeDiff;
        });
        return sorted.filter((notification) => {
          if (
            hiddenBookGroupBookId?.includes(Number(notification?.data?.chapter)) ||
            hiddenBookId?.includes(Number(notification?.data?.chapter)) 
          ) {
            return false;
          } else {
            return true;
          }
        });
      }
      return allNotifications;
    }, [notificationsData, shareNotificationsData, hiddenBookGroupBookId, hiddenBookId, currentUser?.id]);

    const showDrawerBottom = () => {
        setOpenBottom(true);
    };
    const showDrawerMenuBook = () => {
        setOpenMenuBook(true);
    };
    const onCloseBottom = () => {
        setOpenBottom(false);
    };
    const onCloseMenuBook = () => {
        setOpenMenuBook(false);
    };
    const onGetAssignment = () => {
        listAssignmentsAll()
    }

    const currentUrl = location.pathname;
    let isDirector = false;
    if (currentUser?.role === 'admin') {
        isDirector = true;
    }

    useEffect(() => {
        if (currentUrl === '/chat') {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }
    }, [location]);
  useEffect(() => {
        const data = {
                user_id: currentUser.id,
                class_id: currentClass.id,
                session_id: currentGameSession?.session_id,
            }
        const encodeBase64 = (input) => window.btoa(unescape(encodeURIComponent(input)));
        const doublyEncodedData = encodeBase64(encodeBase64(JSON.stringify(data)));
        const handleBeforeUnload = (e) => {
            const message = "Are you sure you want to leave this page?";
            e.preventDefault();
            e.returnValue = message;
            sessionStorage.setItem("userLeaving", "true");
            return message;
        };
        const handleUnload = () => {
            if (currentUser?.role === "teacher"){
                navigator.sendBeacon(`${config.apiGateway.ONEGAME}/close_game_session`, doublyEncodedData);
            } else if (currentUser?.role === "student") {
                navigator.sendBeacon(`${config.apiGateway.ONEGAME}/status_game_session`, doublyEncodedData);
            }
        }

        if (oneGameModal.open) {
            window.addEventListener("beforeunload", handleBeforeUnload);
            window.addEventListener("unload", handleUnload);
        }
        return () => {
            if (oneGameModal.open) {
                window.removeEventListener("beforeunload", handleBeforeUnload);
                window.removeEventListener("unload", handleUnload);
            }
        };
    }, [oneGameModal.open, currentClass, currentUser]);

    useEffect(() => {
        if (location?.pathname === "/ebook" || location?.pathname === "/informateBook"
            || location?.pathname === "/balconCulturalBook" || location?.pathname === "/ConectandomeBook"
            || location?.pathname === "/ComunidadBook" || location?.pathname === "/apBook"
            || location?.pathname === "/apBook" || location?.pathname === "/stories"
        ) {
            return;
        } else {
            ExitFullScreenMode();
        }
    }, [location]);
    useEffect(() => {
        checkAuth({
            currentUser,
            dispatch,
            navigate
        });
    }, [location]);
    const disableScroll = () => {
        disableBodyScroll('Wrapper');
        document.documentElement.style.overflow = 'hidden'; // <html> tag
    };

    const enableScroll = () => {
        document.documentElement.style.overflow = 'auto'; // <html> tag
        document.body.style.overflow = 'auto';
    };
    useEffect(() => {
        if (currentFullScreen && !deteactRotate) {
            disableScroll();
        }
        else {
            enableScroll();
        }
    }, [currentFullScreen, deteactRotate])

    useEffect(() => {
        onCloseMenuBook();
    }, [location.key]);

    useLayoutEffect(() => {
        const handleResize = () => {
            onCloseMenuBook();
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (currentUser?.role === 'student') {
            const allAssignments = [...classActivities, ...classQuizzes];
            { /* onMissingNotification(currentClass, booksAllList, allAssignments, currentUser, null,allowed_books) */}
        }
    }, [currentClass, currentUser, classActivities, classQuizzes,allowed_books])

    useEffect(() => {
        if(!firebaseUser || (firebaseUser && Object.keys(firebaseUser).length === 0)) return;
        const unsubscribe = listenToShareWidgetData(get(currentClass, 'id', ''));
        return () => {
            if (unsubscribe && typeof unsubscribe === 'function') {
                unsubscribe();
            }
        };
    }, [firestore, currentClass?.id, currentUser,firebaseUser])

    const listenToShareWidgetData = (classID) => {
        const isActualMobilePhone = isMobile && 
        !navigator.maxTouchPoints > 1 && 
        !/(ipad|tablet)/i.test(navigator.userAgent);
        if (get(currentUser, "role") === "teacher" && isActualMobilePhone ) {
            return () => { };
        }

        if (!classID || !currentUser) {
            return () => { };
        }
        const collectionRef = collection(firestore, "share_widgets");
        const q = query(collectionRef,
            where("class_id", "==", classID),
            // where("status", "==", true)
        );
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const sharableData = [];
            querySnapshot.forEach((doc) => {
                // filter status for widet traffic 
                sharableData.push({ id: doc.id, ...doc.data() });
            });
            const filterWithoutTraffic = sharableData?.filter((x) => x?.widget_type !== "traffic_signal" && x?.status === true) || [];
            const filterWithTraffic = sharableData?.filter((x) => x?.widget_type === "traffic_signal") || [];
            setSharableWidget(filterWithoutTraffic || [])
            setTrafficWidgetData(filterWithTraffic || []);
        }, (error) => {
            if (error.code === 'permission-denied') {
                console.warn("Permission denied for share_widgets collection. User may not be properly authenticated.");
                return;
            }
            console.error("Error listening to session changes:", error);
        });

        return unsubscribe;
    }

    useEffect(() => {
         if(!firebaseUser || (firebaseUser && Object.keys(firebaseUser).length === 0)) return;
        if (!currentUser?.id) return;
        
        const unsubscribe = listenToUserShareWidgetData(get(currentUser, 'id', ''));
        return () => {
            if (unsubscribe && typeof unsubscribe === 'function') {
                unsubscribe();
            }
        };
    }, [firestore, currentClass?.id, currentUser, firebaseUser])

    const listenToUserShareWidgetData = (userId) => {
        if (get(currentUser, "role") === "teacher" && isMobile) {
            return () => { };
        }

        if (!userId || !currentUser) {
            return () => { };
        }
        const collectionRef = collection(firestore, "share_widgets");
        const userQuery = query(collectionRef,
            where("created_by", "==", userId),
            where("status", "==", true)
        );
        const unsubscribe = onSnapshot(userQuery, (querySnapshot) => {
            const sharableUserData = [];
            querySnapshot.forEach((doc) => {
                sharableUserData.push({ id: doc.id, ...doc.data() });
            });
            setSharableUserWidget(sharableUserData);
        }, (error) => {
            if (error.code === 'permission-denied') {
                console.warn("Permission denied for user share_widgets collection. User may not be properly authenticated.");
                return;
            }
            console.error("Error listening to session changes:", error);
        });

        return unsubscribe;
    }


    useEffect(() => {
        if (currentClass && get(currentUser, "role") === 'teacher') {
            dispatch(handleListClassUsers(currentClass.id))
            sharableUserWidget.forEach((widget) => {             
                if (widget?.class_id !== currentClass.id) {
                    const updatedWidget = {
                        ...widget,
                        status: false,
                        message: "shareable"
                    };
                    createCollectionWidgets(updatedWidget);
                }
            });
        }
        dispatch(handleListAllTeacherFromClass(currentClass?.id))
    }, [currentClass?.id])
    useEffect(() => {
        const allNotifications = [...notificationsData, ...shareNotificationsData];
        const allAssignment = [...classActivities, ...classQuizzes, ...class_game_activity];
        const count = filter(allNotifications, obj => {
            const assignmentId = obj?.data?.id;
            const findData = find(allAssignment, item => item?.session_id ? get(item, 'session_id', '') == assignmentId: get(item, 'data.id', '') == assignmentId);
            const userSeen = obj?.userSeen;
            if (Array.isArray(userSeen)) {
                return !userSeen.includes(currentUser?.id);
            }
            return obj?.seen !== false;
        }).length
        setNotificationCount(count)
    }, [notificationsData, shareNotificationsData, classActivities, classQuizzes, class_game_activity, currentUser?.role, currentUser?.id])

    useEffect(() => {
        setTimeout(() => setMounted(true), 250);
        dispatch(handleGetServertime())
    }, []);
    const getListOfBook = async () => {
        if(currentUser.role == 'admin'||currentUser.role == 'owe_admin'){
            if (!booksAllList || booksAllList.length == 0) {
                await  dispatch(handleListAllBooks())
             }
        } 
    }
    const getUserData = async () => {
        currentUser.parent_of = activeStudentParent;
        await dispatch(handleFetchUserData(currentUser));
    }
  


    const listAssignmentsAll = async () => {
        await dispatch(handleListCustomAssignment(get(currentUser, "role"), get(currentUser, "id")))
    }
    const getSuperAdminPermissions = async () => {
        if (get(currentUser, "role") == 'owe_admin') {
           await dispatch(handleGetUserPermissions(currentUser.id));
        }
    }
    const listGoogleCourseMap = async () => {
        if (get(currentUser, "role") == 'owe_admin') {
            await dispatch(handleListGoogleCourse())
        }
    }
    
    const getWidgets = async () => {
        await dispatch(handleListWidgets(currentUser?.id))
    }
    const getVockBlockStatus = async() =>{
        if(currentUser.role == 'student'){
            await dispatch(handleGetVocabPermissionForStudent(currentUser.id,currentClass.id))
        }
    }
    const listBookPermissions = async()=>{
         if(currentUser && currentUser.role=='teacher'|| currentUser.role=='student' || currentUser.role=='admin' || currentUser?.role === 'parent'){
           await  dispatch(handleListAllowedBooks(currentUser?.role === 'parent' ? activeStudentParent : currentUser.id))
         }
    }
    const listStanderdsData = async()=>{
    }
    const fetchDataOtherAsync = () => {
        Promise.allSettled([
            getWidgets(),
            listGoogleCourseMap(),
            dispatch(handleListChatInfo(currentUser)),
            dispatch(handleGetRubric(currentUser?.id || ""))
            ]
        )
    }
    const fetchDataAsync = () => {
        Promise.allSettled([
             dispatch(handleListBooksCover()),   
            listAllclassSchoologyGradeCategory(),
            fetchContent(),
            listStanderdsData(),
            dispatch(handleListResourcesAndVideo())]
        )
    }
    const listAssignments = async () => {
        if(currentUser.role =='owe_admin'){
        return;
            await Promise.allSettled([
                dispatch(handleListQuizzes()),
                dispatch(handleListActivities())
            ])
        }
    }
    useEffect(() => {
        async function fetchData() {
            //disable if not want to loader
            KEY_FOR_REMOVE.map(key => localStorage.removeItem(key))
            KEY_FOR_REMOVE.map(key => sessionStorage.removeItem(key))
            setLoading(true);
            // return;
            //getListOfBook()
            fetchDataAsync();
            await Promise.allSettled([
                getSuperAdminPermissions(),
                listBookPermissions(),
                getUserData(),
                dispatch(handleListBookOrder()),
                dispatch(handleListBookUnits()),
                getListOfBook(),
                listAssignments(),
                dispatch(handleListAllExamData()),
                dispatch(handleListStory()),
                currentUser.role === 'parent' && dispatch(getParentStudents({ parent_id: currentUser.id }))
            ])
            fetchDataOtherAsync();
            setLoading(false);
        }
        fetchData();
    }, [currentUser])

    useEffect(() => {
        fetchDistrictData();
    }, [currentOrg]);
    useEffect(() => {
        getVockBlockStatus()
    }, [currentUser, currentClass])

    const fetchDistrictData = async () => {
        try {
            if (!isEmpty(currentOrg)) {
                if (currentUser.role == "admin") {
                    await dispatch(handleListGetSchool(currentOrg.id))
                }
            }
        } catch (error) {
            Sentry.captureException(`559 Error in fetchDistrictData: ${error}`);
        }
    };
    const onLogOutPress = () => {
        sessionStorage.removeItem('currentPositionWidgets');
        if (!timmerRunning) {
            clearLoadingState();
            dispatch(handleLogout());
            navigate('/');
        }
        if (currentUser?.role === "teacher" && sharableWidget?.length > 0) {
            sharableWidget.forEach((widget) => {
                const updatedWidget = {
                    ...widget,
                    status: false,
                    message: "shareable"
                };
                createCollectionWidgets(updatedWidget);
            });
        }
    }
    const handleClose = () => {
        setOpen(false);
    };
    const invokeFeedback = () => {
        dispatch(handleInvokeFeedbackForm())
    }
    const checkAndRefreshLatestCode = async () => {
        try {
            const hasNewDeployment = await checkLatestDeploymentRefresh();
            if (!hasNewDeployment) {
                showAlert('You already have latest code.', 'info');
            }
        } catch (error) {
            Sentry.captureException(`Error checking latest deployment in menu: ${error}`);
            showAlert('Unable to check latest code. Please try again.', 'error');
        }
    }
    const openAccessDenineMessage = () => {
        setOpen(true)
        setPopupMessage('Restricted access (legend)')
    }


    const orderedBook = useMemo(() => {
        let order_group = [];
        const books_group_permission = get(orgPermissions, "books_group_permission", []);
        const archived_group = currentClass.archived_group || [];
        (currentClass.books_group || []).forEach((key) => {
            if (books_group_permission.length==0||books_group_permission.includes(key)) {
                const order = find(bookOrder, ["key", key]);
                if(archived_group.includes(key)) return;
                if (order) {
                    order_group.push({
                        key: order.key,
                        title: order.title,
                        color: order.color,
                        books: order && order.order && order.order.map((chapter) => {
                            const book = find(booksAllList, ["id", chapter]);
                            if (book) {
                                if (currentUser.role == "student") {
                                    if (book.onlyTeacher) {
                                        return null;
                                    }
                                }
                                return book;
                            }
                            return null;
                        }).filter(Boolean)
                    })
                }
            }
        });
        return order_group;
    }, [currentClass, orgPermissions, booksAllList, currentUser]);

    const getUserBooks = useCallback(() => {
        let booksData = [];
        orderedBook.forEach(order => {
            booksData.push(...order.books?.filter(k => currentUser.role == 'student' ? !k.onlyTeacher : true))
        })
        return uniqBy(booksData,"id");
    }, [currentUser, orderedBook])

    const navigateToEbook = (chapter) => {
        if (timmerRunning && currentUser?.role === 'student') {
            setPendingChapter(chapter);
            setShowTimerModal(true);
            return;
        }
        
        const demoPages = get(find(booksAllList, ["id", chapter]), "demoPages")
        if (demoStatus && demoPages) {
            navigate(`/ebook?chapter=${chapter}&page=${demoPages.from}&activity=null&quiz=null`);
        } else {
            navigate(`/ebook?chapter=${chapter}&page=1&activity=null&quiz=null`);
        }
    }
    const handleTimerModalConfirm = () => {
        setShowTimerModal(false);
        if (pendingChapter) {
            const demoPages = get(find(booksAllList, ["id", pendingChapter]), "demoPages")
            if (demoStatus && demoPages) {
                navigate(`/ebook?chapter=${pendingChapter}&page=${demoPages.from}&activity=null&quiz=null`);
            } else {
                navigate(`/ebook?chapter=${pendingChapter}&page=1&activity=null&quiz=null`);
            }
        }
        setPendingChapter(null);
    }

    const handleTimerModalCancel = () => {
        setShowTimerModal(false);
        setPendingChapter(null);
    }

    const getHiddenBooks = get(currentClass,"hide_books",[]).map(data => data?.bookId) || [];

    const eBookNav = () => {
        const ebooklist = getUserBooks();
        const isStudent = currentUser?.role === "student";
        const filterBooks = ebooklist?.length > 0 ?
                map(ebooklist, x => {
                    if(isStudent && getHiddenBooks?.includes(x?.id)){
                        return null;
                    }      
                    return {
                        key: x.id,
                        label: (
                            <PaddedBtn onClick={() => {
                                navigateToEbook(x.id);
                                onCloseMenuBook()
                            }} >
                                {x.description }
                            </PaddedBtn>
                        )
                    }
                }).filter(Boolean) : [
                    {
                        key: 'no-books',
                        label: <PaddedBtn>No books</PaddedBtn>
                    }
                ]
                return {
                    items : filterBooks,
                    style : {
                        maxHeight: "300px",
                        overflowY: "auto",
                    }
        };
    };

    const toolbarNav = () => {
        return (<Navigation className="mobileMenu">
            {userClasses.length > 1 && !isDirector && !isTeacherHome ? (
                <NavigationItem>
                    <ButtonLink onClick={e => navigate(currentUser?.role === "teacher" ? "/teacher/home" : "/student/home")}>
                        Classes
                    </ButtonLink>
                </NavigationItem>
            ) : (
                <NavigationItem>
                    <ButtonLink onClick={getRoute}>
                        Dashboard
                    </ButtonLink>
                </NavigationItem>
            )}
            {!isTeacherHome && currentUser?.role !== 'parent' && <NavigationItem>
                <Dropdown
                    menu={eBookNav()}
                    placement="bottomLeft"
                    trigger={['click']}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    overlayClassName="optionsListMenu ebookNavDropdown"
                >
                    <ButtonLink onClick={e => e.preventDefault()}>
                        EBook
                        <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                    </ButtonLink>
                </Dropdown>
            </NavigationItem>}
            {(currentUser?.role === 'student' || currentUser?.role === 'teacher' || currentUser?.role === 'admin') && get(orgPermissions, '1nformate', true) && (
                <NavigationItem>
                    <Dropdown menu={informateNav()} placement="bottomLeft" trigger={['click']}>
                        <ButtonLink onClick={e => e.preventDefault()}>
                            1nformate
                            <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                        </ButtonLink>
                    </Dropdown>
                </NavigationItem>
            )}
            {get(orgPermissions, '1WAYRESOURCES', true) && currentUser?.role !== 'parent' && <NavigationItem>
                <ButtonLink onClick={resources}>
                    1WAYRESOURCES
                </ButtonLink>
            </NavigationItem>}
            {currentUser?.role === 'owe_admin' && (
                <>
                    <NavigationItem>
                        <ButtonLink onClick={logs}>
                            Logs
                        </ButtonLink>
                    </NavigationItem>
                </>
            )}
            {currentUser?.role === 'owe_admin' && (
                <>
                    <NavigationItem>
                        <ButtonLink onClick={schoologyLink}>
                            Schoology
                        </ButtonLink>
                    </NavigationItem>
                </>
            )}
            {currentUser?.role === 'owe_admin' && (
                <>
                    <NavigationItem>
                        <ButtonLink onClick={classlinkLink}>
                            Classlink
                        </ButtonLink>
                    </NavigationItem>
                </>
            )}
            {currentUser?.role === 'owe_admin' && (
                <>
                    <NavigationItem>
                        <ButtonLink onClick={cleverLink}>
                            Clever
                        </ButtonLink>
                    </NavigationItem>
                </>
            )}



            {(currentUser?.role === 'student' || currentUser?.role === 'teacher') && !isTeacherHome && (
                <NavigationItem desktop>
                    <ButtonLink onClick={onWayLessons}>
                        1waylessons
                    </ButtonLink>
                </NavigationItem>
            )}

            {/* Story level for student */}
            {(currentUser?.role === 'student') && get(orgPermissions, '1WAYSTORY', true) && !isTeacherHome && (
                <NavigationItem desktop>
                    <ButtonLink onClick={onStorylevel}>
                        1WayStory
                    </ButtonLink>
                </NavigationItem>
            )}
            {/* Story level for teacher */}
            {(currentUser?.role === 'teacher' || currentUser?.role === 'admin') && get(orgPermissions, '1WAYSTORY', true) && !isTeacherHome && (
                <NavigationItem desktop>
                    <Dropdown menu={storyNav()} placement="bottomLeft" trigger={['click']}>
                        <ButtonLink onClick={e => e.preventDefault()}   >
                            1WayStory
                            <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                        </ButtonLink>
                    </Dropdown>
                </NavigationItem>
            )}
            {(currentUser?.role === 'teacher') && get(orgPermissions, '1WAYTEACHER', true) && !isTeacherHome && (
                <NavigationItem desktop>
                    <Dropdown menu={resourceNav()} placement="bottomLeft" trigger={['click']}>
                        <ButtonLink onClick={e => e.preventDefault()}   >
                            1WAYTEACHER
                            <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                        </ButtonLink>
                    </Dropdown>
                </NavigationItem>
            )}
            {(currentUser?.role === 'student') && get(orgPermissions, '1WAYTEACHER', true) && !isTeacherHome && (
                <NavigationItem>
                    <ButtonLink onClick={onWayTeacher}>
                        1WAYSTUDENT
                    </ButtonLink>
                </NavigationItem>
            )}
            {(currentUser?.role === 'student' || currentUser?.role === 'teacher' || currentUser?.role === 'admin') && !isTeacherHome && get(orgPermissions, 'ap', true) && (
                <NavigationItem desktop>
                    <Dropdown menu={apNav()} placement="bottomLeft" trigger={['click']}>
                        <ButtonLink onClick={e => e.preventDefault()}>
                            AP
                            <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                        </ButtonLink>
                    </Dropdown>
                </NavigationItem>
            )}
            {(currentUser?.role === 'student' || currentUser?.role === 'teacher' || currentUser?.role === 'admin') && get(orgPermissions, 'exams', true) && (
                <NavigationItem>
                    <ButtonLink onClick={onAssessments}>
                        EXAMS
                    </ButtonLink>
                </NavigationItem>
            )}
        </Navigation>)
    };

    const userNav = () => {
        return {
            items: [
                {
                    key: 'change-avatar',
                    label: (
                        <PaddedBtn onClick={showProfilePhotoViewer}>
                            Change Avatar
                        </PaddedBtn>
                    )
                },
                ...((currentUser?.role !== 'student' && !isCanvasUser &&
                document.referrer !== `${window.location.origin}/global-admin-search` &&
                document.referrer !== `${window.location.origin}/data-browsers?tab=parent` &&
                document.referrer !== `${window.location.origin}/data-browsers?tab=see_teachers` &&
                document.referrer !== `${window.location.origin}/data-browsers?tab=see_students`)? [{
                    key: 'reset-password',
                    label: (
                        <PaddedBtn onClick={() => {
                            navigate('/account')
                        }}>
                            Reset Password
                        </PaddedBtn>
                    )
                }, {
                    key: 'view-info',
                    label: (
                        <PaddedBtn onClick={() => {
                            viewInfoModalRef.current?.open();
                        }}>
                            User info
                        </PaddedBtn>
                    )
                }] : []),
                ...(currentUser?.role == 'teacher' && currentUser?.demo !== true ? [{
                    key: 'placement-exam',
                    label: (
                        <PaddedBtn onClick={() => loginAsPlacementAdmin()}>
                            Placement Exam
                        </PaddedBtn>
                    )
                }] : []),
                ...(currentUser?.role === 'teacher' ? [{
                    key: 'manage-classes',
                    label: (
                        <PaddedBtn onClick={() => {
                            navigate(currentUser?.role === "teacher" ? "/teacher/home" : "/student/home")
                        }}>
                            Manage classes
                        </PaddedBtn>
                    )
                }] : []),
                ...(currentUser?.role === 'parent' && userClasses?.length > 1 ? [{
                    key: 'manage-parent-classe',
                    label: (
                        <PaddedBtn onClick={() => {
                            navigate('/parent/home')
                        }}>
                            Manage classes
                        </PaddedBtn>
                    )
                }] : []),
                {
                    key: 'whats-new',
                    label: (
                        <PaddedBtn disabled={isTeacherHome ? true:false} style={{ cursor: isTeacherHome ? 'not-allowed' : 'pointer' }} onClick={() => navigate('/whats-new')}>
                            What's New
                        </PaddedBtn>
                    )
                },
                ...(currentUser?.role === 'student' && userClasses?.length > 1 ? [{
                    key: 'student-manage-classes',
                    label: (
                        <PaddedBtn onClick={() => {
                            navigate(currentUser?.role === "teacher" ? "/teacher/home" : "/student/home")
                        }}>
                            Manage classes
                        </PaddedBtn>
                    )
                }] : []),
                ...(currentUser?.role === 'teacher' && !isTeacherHome ? [{
                    key: 'Permissions',
                    label: (
                        <PaddedBtn onClick={() => setPermissionsModalOpen(true)}>
                            Permissions
                        </PaddedBtn>
                    )
                }] : []),
                ...(currentUser?.role === 'parent' && parentStudents?.length > 1 ? [{
                    key: 'parent-students',
                    label: (
                        <PaddedBtn onClick={() => navigate('/parents-student-home')}>
                            Manage Students
                        </PaddedBtn>
                    )
                }] : []),
               ...(currentUser?.role === 'teacher'? [  {
                    key: 'report-issue',
                    label: (
                        <PaddedBtn onClick={() => invokeFeedback()}>
                            Report an issue
                        </PaddedBtn>
                    )
                }]:[]),
                {
                    key: 'refresh-latest-code',
                    label: (
                        <PaddedBtn onClick={() => checkAndRefreshLatestCode()}>
                            Refresh
                        </PaddedBtn>
                    )
                },
                ...(!(window.self !== window.top) ? [{
                    key: 'logout',
                    label: (
                        <PaddedBtn disabled={timmerRunning} onClick={onLogOutPress}>
                            Logout
                        </PaddedBtn>
                    )
                }] : [])
            ]
        };
    };

    const informateNav = () => {
        return {
            items: [
                {
                    key: 'informate-lessons',
                    label: (
                        <PaddedBtn onClick={() => {
                            navigate('/informate')
                            onCloseMenuBook()
                        }}>
                            1nformate lessons
                        </PaddedBtn>
                    )
                },
                {
                    key: 'informate-blog',
                    label: (
                        <PaddedBtn onClick={() => {
                            navigate('/1nformate')
                            onCloseMenuBook()
                        }}>
                            1nformate blog
                        </PaddedBtn>
                    )
                }
            ]
        };
    };

    const resourceNav = () => {
        return {
            items: [
                {
                    key: 'graphic-organizers',
                    label: (
                        <PaddedBtn onClick={() => {
                            if (demoStatus) {
                                openAccessDenineMessage()
                                onCloseMenuBook()
                            } else {
                                navigate('/graphic_organizers')
                                onCloseMenuBook()
                            }
                        }}>
                            Graphic Organizers
                        </PaddedBtn>
                    )
                },
                {
                    key: '1way-teacher',
                    label: (
                        <PaddedBtn onClick={() => {
                            if (demoStatus) {
                                openAccessDenineMessage()
                                onCloseMenuBook()
                            } else {
                                navigate('/Strategies')
                                onCloseMenuBook()
                            }
                        }}>
                            1WayTeacher
                        </PaddedBtn>
                    )
                }
            ]
        };
    };

    const apNav = () => {
        return {
            items: [
                {
                    key: 'ap-spanish-language',
                    label: (
                        <PaddedBtn onClick={() => {
                            navigate('/ap?id=69')
                            onCloseMenuBook()
                        }}>
                            AP Spanish Language and Culture
                        </PaddedBtn>
                    )
                },
                {
                    key: 'ap-spanish-literature',
                    label: (
                        <PaddedBtn onClick={() => {
                            showAlert("Coming Soon");
                            return;
                            navigate('/ap?id=69')
                            onCloseMenuBook()
                        }}>
                            AP Spanish Literature and Culture
                        </PaddedBtn>
                    )
                }
            ]
        };
    };

    const examsNav = () => {
        return {
            items: [
                {
                    key: 'entry-midterm-final-exams',
                    label: (
                        <PaddedBtn onClick={entryMidtermFinalExams}>
                            Entry, Midterm, Final Exams
                        </PaddedBtn>
                    )
                },
                {
                    key: 'standard-based-exam',
                    label: (
                        <PaddedBtn onClick={standardBasedExam}>
                            Standard Based Exam
                        </PaddedBtn>
                    )
                },
                ...(get(currentUser, "role") !== "student" ? [{
                    key: 'ap-spanish-literature',
                    label: (
                        <PaddedBtn onClick={unitExamAndQuizzes}>
                            Unit Exam and Quizzes (book)
                        </PaddedBtn>
                    )
                }] : [])
            ]
        };
    };

    const notificationNav = () => {
        return {
            items: [
                {
                    key: 'notification-content',
                    label: (
                        <NotificationContainer>
                            <NotificationHeader>
                                <TextHeader>Notifications</TextHeader>
                                {filterNotificationData?.length > 0 && (
                                    <ReadAllBtn className='markAllDone' onClick={() => {
                                        onReadAllNotification(notificationsData)
                                    }} >
                                        <TextReadAll>{markAllDoneNotificationLoading ? <Loading size={16} /> : 'Mark All As Viewed'}</TextReadAll>
                                    </ReadAllBtn>
                                )}
                            </NotificationHeader>
                            <NotificationBody>
                                {filterNotificationData?.length > 0 ? (
                                    <>
                                        {map(filterNotificationData?.slice(0, 5), (item, index) => {
                                            return (
                                                <SingleNotificationSection item={item} index={index} key={index} />
                                            )
                                        }
                                        )}
                                    </>
                                )
                                    : (
                                        <NoNotificationText>
                                            <div className="notifiPlaceholder">
                                                <React.Suspense fallback={null}>
                                                    <Lottie animationData={NOTIFICATIONICONS.poster} />
                                                </React.Suspense>
                                            </div>
                                        </NoNotificationText>
                                    )}
                            </NotificationBody>
                            <ViewAllBtn
                                style={{
                                    opacity: filterNotificationData?.length > 0 ? 1 : 0.7,
                                    display: !filterNotificationData?.length > 0 && 'none'
                                }}
                                disabled={filterNotificationData?.length > 0 ? false : true}
                                onClick={() => {
                                    navigate('/notification')
                                    setIsnotification(false);
                                    setIsnotificationMob(false);
                                }}>View All</ViewAllBtn>
                        </NotificationContainer>
                    )
                }
            ]
        };
    };

    const storyNav = () => {
        return {
            items: [
                {
                    key: 'story',
                    label: (
                        <PaddedBtn onClick={() => {
                            onStorylevel()
                            onCloseMenuBook()
                        }}>
                            Story
                        </PaddedBtn>
                    )
                },
                ...(get(currentUser, "role") !== "student" ? [{
                    key: 'story-gradebook',
                    label: (
                        <PaddedBtn onClick={() => {
                            navigate('/story/gradebook')
                            onCloseMenuBook()
                        }}>
                            Gradebook
                        </PaddedBtn>
                    )
                }] : [])
            ]
        };
    };

    const onReadAllNotification = async (data) => {
        try{
            setMarkAllDoneNotificationLoading(true);
            const allNotifications = [...notificationsData, ...shareNotificationsData];
            const regularNotifications = filter(allNotifications, obj => obj.type !== 'share_notification');
            const shareNotifications = filter(allNotifications, obj => obj.type === 'share_notification');
            
            if (regularNotifications.length > 0) {
                await markAllAsRead(get(currentUser, 'id', ''), get(currentClass, 'id', ''))
            }
            
            if (shareNotifications.length > 0 && currentUser?.id) {
                const shareNotificationIds = map(shareNotifications, notif => notif.id);
                await updateShareNotificationsBatch(shareNotificationIds, currentUser.id);
            }
        }catch(error){
            console.log(error);
        }finally{
            setMarkAllDoneNotificationLoading(false);
        }
    }

    const getRoute = () => {
        if (isTeacherHome) {
            return;
        }
        if (currentUser?.role === 'admin') {
            navigate('/district');
        } else if (currentUser?.role === 'teacher') {
            navigate('/admin/class?view=home');
            // navigate('/teacher/home');
        } else if (currentUser?.role === 'owe_admin') {
            navigate('/dashboard');
        } else if (currentUser?.role === 'parent') {
            navigate('/parent/class?view=home');
        }else if (currentUser?.role === 'placement_admin') {
            navigate('/placement_exam_list');
        }
        else {
            navigate('/student/class?view=home');
        }
    };

    const logs = () => {
        navigate('/logs');
    };
    const schoologyLink = () => {
        navigate('/schoology');

    };

    const classlinkLink = () => {
        navigate('/classlink');
    };
    const cleverLink = () => {
        navigate('/clever');
    };
    const resources = () => {
        navigate('/resources');
    };

    const pd = () => {
        navigate('/pd');
    }
    const onIplayGame = () => {
        navigate("/home-game");
    };

    const onAssessments = () => {
        navigate("/exams");
    }

    const entryMidtermFinalExams = () => {
        navigate("/exams");
    }
    const standardBasedExam = () => {
        if(AllstandardExam.length == 0){
            return showAlert('Coming Soon')
        }
        navigate("/standard-based-exam");
    }
    const unitExamAndQuizzes = () => {
        navigate("/unit-exam-and-quizzes-book");
    }

    const onWayTeacher = () => {
        if (demoStatus) {
            openAccessDenineMessage()
        } else {
            navigate('/Strategies')
        }
    }

    const onStorylevel = () => {
        navigate("/story-levels");
    }

    const getLink = (link) => {
        if (typeof link == "string") {
            return link.match(/\bhttps?:\/\/\S+/gi)[0];
        } else if (typeof link == "object") {
            return get(link, "href", "").match(/\bhttps?:\/\/\S+/gi)[0];
        } else {
            return '';
        }
    }
    const getHrefTitle = (link) => {
        if (typeof link == "string") {
            return link;
        } else if (typeof link == "object") {
            return link.title && link.title.length > 0 ? link.title : link.href;
        } else {
            return ''
        }
    }

    const gridStyle = {
        width: "100%",
        textAlign: "center",
        padding: "7px",
        cursor: "pointer"
    };

    const gridStyleSeen = {
        width: "100%",
        textAlign: "center",
        padding: "7px",
        cursor: "pointer",
        backgroundColor: "#e8e4ee"
    };

    const onNotification = async () => {
        setIsnotification(!isnotification);
         setIsnotificationMob(!isnotificationMob)
    }
    const onNotificationMob = async () => {
         setIsnotificationMob(!isnotificationMob)
    }

    const getAssignmentWithSubmission = async () => {
        dispatch(handleListClassActivities(currentClass.id));
        dispatch(handleListClassQuizzes(currentClass.id));
        dispatch(handleListClassGameActivity(currentClass.id));
    }



    const createNotification = async (data) => {
        if(data?.type !== "instruction"){
            if (data?.id && currentUser?.id) {
                setNotificationsData(prev => {
                    const updated = prev.map(notif => {
                        if (notif.id === data.id || notif.firebaseDocId === data.firebaseDocId) {
                            const existingUserSeen = notif.userSeen || [];
                            if (!existingUserSeen.includes(currentUser.id)) {
                                return {
                                    ...notif,
                                    userSeen: [...existingUserSeen, currentUser.id]
                                };
                            }
                        }
                        return notif;
                    });
                    return updated;
                });
                await updateCollectionNotification(data?.id, get(currentUser, 'id', ''))
            }
        }
        if (data.seen) {
            const notificationData = {
                ...data,
                seen: false
            }
        } else {
            return;
        }
    }



    const onNotificationClick = async (data) => {
      try {
        if (data?.type === 'instruction' && data?.data?.urlPath) {
            if (currentUser?.role === 'teacher' && currentUser?.id) {
                await dispatch(handleListInstructionByUser(currentUser.id));
              } else if (currentUser?.role !== 'teacher' && currentClass?.id) {
                await dispatch(handleListInstructionByClass(currentClass.id));
              }
              if (currentUser?.role === 'student') {
                const url = new URL(data?.data?.urlPath, window.location.origin);
                url.searchParams.set('openInstruction', 'true');
                navigate(url.pathname + url.search + url.hash);
              } else {
                navigate(data?.data?.urlPath);
              }    
          return;
        }
        if (data?.data?.assignfrom && data?.data?.assignfrom?.urlPath) {
          navigate(data?.data?.assignfrom?.urlPath);
          return;
        }
        const chapter = get(data, "data.chapter", '');
        const gameGradeRedirect = ['debate', 'game', 'bingo', 'worksheet'].includes(get(data, "data.assignmentType", '')) && data?.type === 'update_grade';
        if (currentUser?.role === 'student' && chapter !== '' && chapter !== undefined && !gameGradeRedirect && !isVideo(chapter, resourcess) && isExamHidden(chapter)) {
          showAlert('Your teacher has hidden this exam and you are no longer able to take it.', 'info');
          return;
        }
        const assignmentData = data?.data;
        const isEngageAssignment = assignmentData?.config_assignment?.isFrom === 'engagement';
        let engageData = null;
        if (isEngageAssignment) {
            engageData = findEngageData(assignmentData);
        }
        const url = getAssignmentNavigationUrl(redirectToBook(data?.data, data?.type), data);
        if (url) {
          if (url.includes(location.pathname)) {
            navigate(url);
            if (isEngageAssignment && engageData && engageData?.imageData?.length > 0) {
              setTimeout(() => {
                updatePopUpAtOnce(false);
                dispatch(updateUI({ 
                  openEngageModalTeacher: { 
                    open: true, 
                    id: engageData?.id,
                    engagePageId: engageData?.pageId,
                    data: engageData?.imageData,
                    engageName: engageData?.sequence
                  } 
                }));
              }, 500);
            } else {
              setTimeout(() => {
                window.location.reload();
              }, 500);
            }
          } else {
            navigate(url);
          }
        } else {
          showAlert('Currently unavailable to open.', 'error');
        }
      } catch (error) {
        Sentry.captureException(`560 Error in onNotificationClick: ${error}`);
        console.log(error);
      }
    };



    const onStudentEndNotification = (data, findData) => {
        const now = new Date();
        if (data.type == 'delete_activity' || data?.type == 'delete_quiz') {
            return;
        } else if (new Date(data?.data?.scheduleAt) > now) {
            showAlert('This activity is scheduled to start soon. Please wait until it begins.', 'info');
        } else {
            onNotificationClick(data);
            setIsnotification(false);
            setIsnotificationMob(false);
        }
    }

    const markNotificationAsSeen = async (data) => {
        if (data?.id && currentUser?.id) {
            setShareNotificationsData(prev => prev.map(notif => {
                if (notif.id === data.id) {
                    return {
                        ...notif,
                        userSeen: [...(notif.userSeen || []), currentUser.id]
                    };
                }
                return notif;
            }));
            await updateShareNotification(data.id, currentUser.id);
        }
    }

    const onRoleCheck = async (data) => {
        // Handle share notifications separately
        if (data?.type === 'share_notification') {
            setloadingQuestions(true);
            const shareData = data.shareNotificationData || data;
            const assignmentType = shareData?.data?.assignmentType || shareData?.assignmentType;
            
            let notificationChapter = data?.data?.chapter || 
                                    shareData?.data?.chapter || 
                                    shareData?.chapter || 
                                    shareData?.bookId || 
                                    data?.data?.bookId ||
                                    data?.shareNotificationData?.chapter ||
                                    data?.shareNotificationData?.bookId;
            
            let notificationPage = data?.data?.page || 
                                data?.data?.pageId ||
                                shareData?.data?.page || 
                                shareData?.data?.pageId ||
                                shareData?.page || 
                                shareData?.pageId ||
                                data?.shareNotificationData?.page ||
                                data?.shareNotificationData?.pageId;
            
            if (!notificationPage || !notificationChapter) {
                const url = shareData?.url || data?.data?.url || data?.url;
                if (url) {
                    const urlMatch = url.match(/[?&]chapter=(\d+)/);
                    const pageMatch = url.match(/[?&]page=(\d+)/);
                    if (!notificationChapter && urlMatch) {
                        notificationChapter = urlMatch[1];
                    }
                    if (!notificationPage && pageMatch) {
                        notificationPage = pageMatch[1];
                    }
                }
            }
            
            const params = new URLSearchParams(window.location.search);
            const currentChapter = params.get("chapter") || "";
            const currentPage = params.get("page") || "";
            const isSamePage = Number(currentChapter) === Number(notificationChapter) && 
                              Number(currentPage) === Number(notificationPage);
            
            if (assignmentType === 'story' || shareData?.type === 'soy_historias') {
                const classId = shareData?.data?.class_id || shareData?.class_id || get(currentClass, 'id', '');
                
                await markNotificationAsSeen(data);
                
                const isEbookPath = ['/ebook', '/balconCulturalBook', '/stories', '/video'].some((path) =>
                    location.pathname.includes(path)
                );
                
                if (isEbookPath) {
                    await dispatch(handleListStoryAiConfig({
                        chapter: notificationChapter,
                        user_id: get(currentUser, "id", ""),
                        class_id: classId
                    }, currentUser?.role === 'student'));
                }
                
                const url = shareData?.url || data?.data?.url;
                
                dispatch(updateUI({
                    soyHistoriasView: {
                        type: 'soyHistoriasView',
                        data: shareData?.shared_data,
                        chapter: notificationChapter,
                        page: notificationPage,
                        open: true,
                        isNotification: true
                    }
                }));
                
                if (url) {
                    setTimeout(() => {
                        navigate(url);
                    }, 0);
                }
                
                setloadingQuestions(false);
                setIsnotification(false);
                setIsnotificationMob(false);
                return;
            }
            
            await markNotificationAsSeen(data);
            
            if (currentUser?.role === 'student' && notificationChapter && !isVideo(notificationChapter, resourcess) && isExamHidden(notificationChapter)) {
                showAlert('Your teacher has hidden this exam and you are no longer able to take it.', 'info');
                setloadingQuestions(false);
                setIsnotification(false);
                setIsnotificationMob(false);
                return;
            }
            const assignmentData = shareData?.data || data?.data;
            if (assignmentData?.config_assignment?.isFrom === 'engagement') {
                const engageData = findEngageData(assignmentData);
                if (engageData && engageData?.imageData?.length > 0) {
                    updatePopUpAtOnce(false);
                    dispatch(updateUI({ openEngageModalTeacher: { open: true, data: engageData?.imageData } }));
                }
            }
            
            if (data?.data?.assignmentType === 'worksheet' && currentUser?.id) {
                if (isSamePage) {
                    await dispatch(handleListWorkSheet(notificationChapter, currentUser?.role, currentUser?.id, 100, 0, true, null, currentClass?.id));
                }
                onGetAssignment();
            }
            
            const url = shareData?.url || data?.data?.url;
            if (url) {
                if (!isSamePage && data?.data?.assignmentType === 'worksheet') {
                    navigate(url);
                    setTimeout(() => {
                      window.location.reload();
                    }, 500);
                } else {
                    navigate(url);
                }
            } else {
                await onNotificationClick(data);
            }
            
            setloadingQuestions(false);
            setIsnotification(false);
            setIsnotificationMob(false);
            return;
        }
        
        // Handle instruction notifications separately
        if (data?.type === 'instruction') {
            setloadingQuestions(true);
            await onNotificationClick(data);
            setloadingQuestions(false);
            setIsnotification(false);
            setIsnotificationMob(false);
            return;
        }
        
        // Try to find the assignment
        setloadingQuestions(true);
        let assignmentId = get(data, "data.id", '');
        let allAssignment = [...classActivities, ...classQuizzes, ...class_game_activity];
        let findData = find(allAssignment, obj => obj?.session_id ? get(obj, 'session_id', '') == assignmentId : get(obj, 'data.id', '') == assignmentId ? get(obj, 'data.id', '') == assignmentId : get(obj, 'activityId', '') == assignmentId);
    
        // If not found, fetch and try again
        if (!findData) {
          await dispatch(handleListClassSubmissions(get(currentClass, "id")))
          allAssignment = [...classActivities, ...classQuizzes, ...class_game_activity];
          findData = find(allAssignment, obj => obj?.session_id ? get(obj, 'session_id', '') == assignmentId : get(obj, 'data.id', '') == assignmentId);
        }
        if (get(currentUser, "role") === "teacher") {
            if ([SYSTEM_NOTIFICATION_TYPES.UPDATE_ACTIVITY, SYSTEM_NOTIFICATION_TYPES.UPDATE_QUIZ].includes(data?.type)) {
                const assignmentId = get(data, "data.id", '');
                const classId = get(currentClass, "id");
                await Promise.allSettled([
                createNotification(data),
                dispatch(handleListActivityOrQuizData(assignmentId, classId)), 
                dispatch(handleListSubmissionsByAssignmentAndClass(assignmentId, classId))
                ]);
                if (findData) {
                    setReviewData(findData);
                    toggleAssignmentDrawer(true);
                } else {
                    setOpen(true)
                    setPopupMessage('The Assignment is already deleted')
                }
                setloadingQuestions(false);
                setIsnotification(false);
                setIsnotificationMob(false);
                return;                 
            }
            await Promise.allSettled([
                createNotification(data),
                getAssignmentWithSubmission()
            ]);
            await dispatch(handleListClassActivities(currentClass.id));
            await dispatch(handleListClassSubmissions(get(currentClass, "id")))
            if (findData) {
                await dispatch(handleListClassSubmissions(get(currentClass, "id")))
                setReviewData(findData);
                toggleAssignmentDrawer(true);
            } else {
                setOpen(true)
                setPopupMessage('The Assignment is already deleted')
            }
            setloadingQuestions(false);
            setIsnotification(false);
            setIsnotificationMob(false);
        } else {
            if (data.type === "play_game_notification") {
                setIsnotification(false);
                createNotification(data);
                dispatch(handleGamePopupNotify(data.data))
            } else {
                const classes = get(data?.data, 'classes', [])?.find((obj) => obj.id === currentClass.id);
                const classConfigExist = classes?.users?.some((user) => user === currentUser.id);
                if (classConfigExist === false) {
                    showAlert('This assignment is not available for you.', "info")
                    return;
                };
                const assignmentData = findData?.data || data?.data;
                if (assignmentData?.config_assignment?.isFrom === 'engagement') {
                    const engageData = findEngageData(assignmentData);
                    if (engageData && engageData?.imageData?.length > 0) {
                        updatePopUpAtOnce(false);
                        dispatch(updateUI({ openEngageModalTeacher: { open: true, data: engageData?.imageData } }));
                    }
                }
                await Promise.allSettled([
                    createNotification(data),
                    // getClassAssignment()
                ]);
                onStudentEndNotification(data, findData);
            }
            setloadingQuestions(false);
        }
    }

    const fetchActiveGameSession = async () => {
        if(loaderForFetchSessionData){
            return;
        }
        setLoaderForFetchSessionData(true);
      try {
        if (currentClass.id && currentUser?.role === "student") {
          const sessionId = search?.sessionId;
          if (sessionId) {
            localStorage.setItem("game_session_id", sessionId);
          }
          const session_data = await dispatch(
            handleGetClassActiveGameSession(
              currentClass.id,
              currentUser.id,
              search?.sessionId
            )
          );
          if (
            session_data &&
            session_data.session_id &&
            session_data.status != "ended"
          ) {
            openPlayerModal(session_data);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoaderForFetchSessionData(false);
      }
    };

    useEffect(() => {
        fetchActiveGameSession();
    }, [currentClass]);


    const activeOrUnActiveGameSession = () => { 
        if(playGameModal.open) return;
        fetchActiveGameSession()
    }

    useDeviceActiveState(activeOrUnActiveGameSession); 
    useFetchUnseenNotifications({filterNotificationData});
        
    const SingleNotificationSection = ({ item }) => {
        const inputDate = get(item, "modified", "") || get(item, "shared_time", "");
        // const seenStatus = get(item, "seen", '');
        const userSeen = get(item, "userSeen", '');
        const seenStatus = userSeen ? !userSeen.includes(currentUser?.id) : get(item, "seen", '');
        const assignmentId = get(item, "data.id", '')
        const scheduleAt = get(item, "data.scheduleAt", '')
        const findData = find(allAssignment, obj => obj?.session_id ? get(obj, 'session_id', '') == assignmentId : get(obj, 'data.id', '') == assignmentId)
        let result = "Invalid Date";
        if (inputDate) {
            const date = new Date(inputDate);
            if (!isNaN(date.getTime())) {
                const formattedDate = date.toLocaleDateString("en-US", {
                    weekday: "short",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                });

                const formattedTime = date.toLocaleTimeString("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                });
                result = `${formattedDate} at ${formattedTime}`;
            }
        }

        return (
            <Badges.Ribbon text={seenStatus ? 'New' : 'Done'} color={seenStatus ? 'red' : '#03989e'}>
                <Card.Grid style={seenStatus ? gridStyleSeen : gridStyle} onClick={() => {
                    setSelectedNotification(item);
                    onRoleCheck(item, findData)
                }}>
                    <Row>
                        <Col xs={24} lg={24}>
                            <NotificationsMainSection>
                                {/* {seenStatus && (
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                }}>
                                    <SeenSection />
                                </div>
                            )} */}
                                <Image
                                    src={modalSrc(item, findData)}
                                    alt={""}
                                />
                                <NotificationSection>
                                    
                                    <TextTitle className='text-wrap d-block'>{item.displayName}</TextTitle>
                                     
                                    <TextDateTitle>
                                      {item.message}
                                      {scheduleAt && new Date(scheduleAt) > new Date() && (
                                        <>
                                          <br />
                                          <span style={{ color: '#1890ff' }}>
                                            Scheduled to start at: {new Date(scheduleAt).toLocaleString('en-US', {
                                              year: 'numeric',
                                              month: 'short',
                                              day: 'numeric',
                                              hour: 'numeric',
                                              minute: 'numeric',
                                              hour12: true
                                            })}
                                          </span>
                                        </>
                                      )}
                                    </TextDateTitle>
                                    <TextDate>{result}</TextDate>
                                </NotificationSection>
                            </NotificationsMainSection>
                        </Col>
                    </Row>
                </Card.Grid>
            </Badges.Ribbon>
        );
    };

    const onWayLessons = () => {
        navigate("/OneWayLessons");
    }
    const getUserProfileImg = useMemo(() => {
        if (profile_config && profile_config.config) {
            const avt = getAvatar(profile_config.config.profile_pic)
            if (avt) {
                return avt
            }
        }
        return userImg;
    }, [profile_config])
        const loginAsPlacementAdmin = async ()=>{
            await openLoginInNewWindow(currentUser.id,'placement_admin');
       }
    return (<SentryWrap>
        <CommonWrapper />
    <WrapperChatSocket currentUser={currentUser} currentClass={currentClass} />
    {loading || loadingClassBooks ? (
        <CenterContainer>
            <InitialLoading mounted={mounted} />
        </CenterContainer>
    ) : (
        <>
        <SpinLoader dataloader={loadingQuestions} />
        <div style={{ position: "relative" }} onClick={() => {
                if (isnotification || isnotificationMob) {
                setIsnotification(false);
                setIsnotificationMob(false);
            }
            
        }}>
            <StudentGroupGradeBook />
            {(get(currentUser, "role") == "student" || get(currentUser, "role") == "teacher") && !isTeacherHome && <JoinGameNotificationModal/>} 
            <OPenOneGame iframeUrl={oneGameModal.iframeUrl} open1game={oneGameModal.open}  />
            <ProfileAvatarPicker />
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    <strong>ALERT:</strong> {popupMessage}
                </Alert>
            </Snackbar>
           {assignmentDrawer && selectedNotification?.id ? <AssignmentReviewByNotify assignment={reviewData} assignmentDrawer={assignmentDrawer} selectedNotification={selectedNotification} oncloseDrawer={() => {
                toggleAssignmentDrawer(false)
            }} />:null}
            <FeedbackForm />
            {!isTeacherHome && is_teacher && <AssignableSharePopup currentClass={currentClass} currentUser={currentUser} onGetAssignment={onGetAssignment} onNoData={(msg) => {
                setOpen(true)
                setPopupMessage(msg)
            }} />}
            {!isTeacherHome && is_student && <ShareNotificationWithStudents currentClass={currentClass} currentUser={currentUser} />}
            <AlertViewModal />

            <EbookTimeModal open={showTimerModal} onOk={handleTimerModalConfirm} onCancel={handleTimerModalCancel} />
           {is_student && <BooksNotFoundRefreshModal
                orderedBook={orderedBook}
                loadingClassBooks={loadingClassBooks}
                booksAllList={booksAllList}
                allBooks={allBooks}
                currentUser={currentUser}
                currentClass={currentClass}
            />}
            
            {/* Wheel modal  */}
             <BottomIcons sharableWidget={sharableWidget} trafficWidgetData={trafficWidgetData} />
            <MessageAlertViewer />
            <DemoModal open={modalOpen} handleClose={() => toggleModal(false)} message={currentOrg?.demo ? 'Not available in demo' : 'Chapter is currently under maintenance'} />
            <DemoModal open={modalOpenVideosDemo} handleClose={() => toggleModalVideosDemo(false)} message={'Not available in demo'} />
            
            {/* Permissions Modal */}
            {!isTeacherHome && <TeacherPermission currentUser={currentUser} currentClass={currentClass} permissionsModalOpen={permissionsModalOpen} setPermissionsModalOpen={setPermissionsModalOpen} />}
            {/* <TeacherPermission currentUser={currentUser} currentClass={currentClass} permissionsModalOpen={permissionsModalOpen} setPermissionsModalOpen={setPermissionsModalOpen} /> */}

            <Container>
                    {currentFullScreen ? null : 
                        get(currentUser, 'role', '') !== 'owe_admin' && get(currentUser, 'role', '') !== 'admin'&& !is_placement_admin_user && (
                    <NavWrap className="cstmHeader">
                        <TopBar>
                            <MaxWidthContainer laptop={laptop} height='100%' informateBook={location.pathname === "/informateBook"}>
                                <InnerContainer>
                                    <Navigation>
                                        <NavigationItemLogo desktop>
                                            <ButtonLinkLogo onClick={getRoute}>
                                                <LogoIcon />
                                            </ButtonLinkLogo>
                                        </NavigationItemLogo>
                                        <>
                                            {userClasses?.length > 1 && !isTeacherHome && currentUser?.role === 'teacher' && (
                                                <NavigationItem laptop={laptop} desktop>
                                               
                                                    <TopDrawer children={<ButtonLink
                                                        laptop={laptop}
                                                        to="desktop"
                                                        >
                                                        CLASSES
                                                        <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                                        </ButtonLink>} />
                                                </NavigationItem>
                                            )}
                                            {/* Teacher drawer */}
                                        </>
                                        <>
                                        {userClasses?.length > 1 && !isTeacherHome && currentUser?.role === 'student' && (
                                            <NavigationItem laptop={laptop} desktop>
                                                <TopDrawer children={<ButtonLink
                                                    laptop={laptop}
                                                    to="desktop"
                                                >
                                                CLASSES
                                                <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                                </ButtonLink>} />
                                            </NavigationItem>
                                        )}
                                        </>

                                        {!isTeacherHome && currentUser?.role !== 'parent' && <NavigationItem laptop={laptop}  desktop>
                                            <Dropdown
                                                menu={eBookNav()}
                                                placement="bottomLeft"
                                                trigger={['click']}
                                                overlayClassName="optionsListMenuEbook ebookNavDropdown"
                                            >
                                                <ButtonLink laptop={laptop} to={"desktop"}   onClick={e => e.preventDefault()}>
                                                    EBook
                                                    <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                                </ButtonLink>
                                            </Dropdown>
                                        </NavigationItem>}
                                        {(currentUser?.role === 'student' || currentUser?.role === 'teacher' || currentUser?.role === 'admin') && get(orgPermissions, '1nformate', true) && !isTeacherHome && (
                                            <NavigationItem laptop={laptop} desktop>
                                                <Dropdown menu={informateNav()} placement="bottomLeft" trigger={['click']}>
                                                    <ButtonLink onClick={e => e.preventDefault()} laptop={laptop} to="desktop">
                                                        1nformate
                                                        <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                                    </ButtonLink>
                                                </Dropdown>
                                            </NavigationItem>
                                        )}


                                        {get(orgPermissions, '1WAYRESOURCES', true) && !isTeacherHome && currentUser?.role !== 'parent' && <NavigationItem laptop={laptop} desktop>
                                            <ButtonLink laptop={laptop}  to={"desktop"}  onClick={resources}>
                                                1WAYRESOURCES
                                            </ButtonLink>
                                        </NavigationItem>}
                                        {currentUser?.role === 'owe_admin' && (
                                            <>
                                                <NavigationItem desktop>
                                                    <ButtonLink laptop={laptop}  to={"desktop"}  onClick={logs}>
                                                        Logs
                                                    </ButtonLink>
                                                </NavigationItem>
                                            </>
                                        )}
                                        {currentUser?.role === 'owe_admin' && (
                                            <>
                                                <NavigationItem laptop={laptop} desktop>
                                                    <ButtonLink laptop={laptop}  to={"desktop"}  onClick={schoologyLink}>
                                                        Schoology
                                                    </ButtonLink>
                                                </NavigationItem>
                                            </>
                                        )}
                                        {currentUser?.role === 'owe_admin' && (
                                            <>
                                                <NavigationItem laptop={laptop} desktop>
                                                    <ButtonLink laptop={laptop}  to={"desktop"}  onClick={classlinkLink}>
                                                        Classlink
                                                    </ButtonLink>
                                                </NavigationItem>
                                            </>
                                        )}
                                        {currentUser?.role === 'owe_admin' && (
                                            <>
                                                <NavigationItem laptop={laptop} desktop>
                                                    <ButtonLink laptop={laptop}  to={"desktop"}  onClick={cleverLink}>
                                                        Clever
                                                    </ButtonLink>
                                                </NavigationItem>
                                            </>
                                        )}



                                        {(currentUser?.role === 'student' || currentUser?.role === 'teacher') && !isTeacherHome && (
                                            <NavigationItem laptop={laptop} desktop>
                                                <ButtonLink laptop={laptop}  to={"desktop"}  onClick={onWayLessons}>
                                                    1waylessons
                                                </ButtonLink>
                                            </NavigationItem>
                                        )}
                                        {/* Story level for student */}
                                        {(currentUser?.role === 'student') && get(orgPermissions, '1WAYSTORY', true) && !isTeacherHome && (
                                            <NavigationItem laptop={laptop} desktop>
                                                <ButtonLink laptop={laptop} to="desktop" onClick={onStorylevel}>
                                                    1WayStory
                                                </ButtonLink>
                                            </NavigationItem>
                                        )}
                                        {/* Story level for teacher */}
                                        {(currentUser?.role === 'teacher' || currentUser?.role === 'admin') && get(orgPermissions, '1WAYSTORY', true) && !isTeacherHome && (
                                            <NavigationItem laptop={laptop} desktop>
                                                <Dropdown menu={storyNav()} placement="bottomLeft" trigger={['click']}>
                                                    <ButtonLink onClick={e => e.preventDefault()} laptop={laptop} to="desktop">
                                                        1WayStory
                                                        <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                                    </ButtonLink>
                                                </Dropdown>
                                            </NavigationItem>
                                        )}
                                        {(currentUser?.role === 'teacher') && get(orgPermissions, '1WAYTEACHER', true) && !isTeacherHome && (
                                            <NavigationItem laptop={laptop} desktop>
                                                <Dropdown menu={resourceNav()} placement="bottomLeft" trigger={['click']}>
                                                    <ButtonLink laptop={laptop} className={laptop && "laptop-header-1way-teacher-hidden"}  to={"desktop"}  onClick={e => e.preventDefault()}   >
                                                        1WAYTEACHER
                                                        <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                                    </ButtonLink>
                                                </Dropdown>
                                            </NavigationItem>
                                        )}
                                        {(currentUser?.role === 'student') && get(orgPermissions, '1WAYTEACHER', true) && !isTeacherHome && (
                                            <NavigationItem laptop={laptop} desktop>
                                                <ButtonLink laptop={laptop}  className={laptop && "laptop-header-one-way-student-hidden"} to={"desktop"}  onClick={onWayTeacher}>
                                                    1WAYSTUDENT
                                                </ButtonLink>
                                            </NavigationItem>
                                        )}

                                        {(currentUser?.role === 'student' || currentUser?.role === 'teacher' || currentUser?.role === 'admin') && get(orgPermissions, 'ap', true) && !isTeacherHome && (
                                            <NavigationItem laptop={laptop} desktop>
                                                <Dropdown menu={apNav()} placement="bottomLeft" trigger={['click']}>
                                                    <ButtonLink laptop={laptop}  to={"desktop"}  onClick={e => e.preventDefault()}   >
                                                        AP
                                                        <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                                    </ButtonLink>
                                                </Dropdown>
                                            </NavigationItem>
                                        )}
                                        {(currentUser?.role === 'student' || currentUser?.role === 'teacher' || currentUser?.role === 'admin') && get(orgPermissions, 'exams', true) && !isTeacherHome && (
                                             <NavigationItem laptop={laptop} desktop>
                                             <Dropdown menu={examsNav()} placement="bottomLeft" trigger={['click']}>
                                                 <ButtonLink laptop={laptop}  to={"desktop"} onClick={e => e.preventDefault()}>
                                                     EXAMS
                                                     <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                                 </ButtonLink>
                                             </Dropdown>
                                            </NavigationItem>
                                        )}
                                    </Navigation>

                                    <MenuIconsWrapper laptop={laptop} className='menuIconsCstm menuIconBadge'>
                                        <Row>
                                            {(currentUser?.role === 'teacher' || currentUser?.role === 'student') && !isTeacherHome && (
                                                <RowItem>
                                                    <SearchComponent />
                                                </RowItem>
                                            )}
                                            {(currentUser?.role === 'teacher' || currentUser?.role === "student") && !isTeacherHome && (
                                                <RowItem style={{ cursor: 'pointer' }}>
                                                    <Dropdown overlayClassName="notificationPopOver" menu={notificationNav()} placement="bottom" trigger={['click']} open={isnotification} >
                                                        <CustomBtn onClick={() => {
                                                            onNotification()
                                                        }}
                                                        >
                                                            <Badge style={{zIndex: 0}} overlap="rectangular" badgeContent={notificationCount} color="error" variant="standard">
                                                              <img src={customNotifySvg} alt="" title="" />
                                                            </Badge>
                                                        </CustomBtn>
                                                    </Dropdown>
                                                </RowItem>
                                            )}
                                                <HeaderChatNavButton />
                                        </Row>
                                        <Row>
                                            {currentUser?.role === 'teacher' && !isTeacherHome && <ActiveStudentStatus activeStatus={activeStatus} setActiveStatus={setActiveStatus} />}
                                        </Row>
                                    </MenuIconsWrapper>

                                    <Row className="iconsMenuItem">
                                        <RowContainer className="usrDetailUpr" border={currentUser?.role === 'teacher'}>

                                            <Dropdown className="usrDetailInr hideOnMobile" menu={userNav()} placement="bottomRight" trigger={['click']}>
                                                <UserContainer>
                                                    <UserDetails className="usrDetail">
                                                        <div className="usrDetailInfoCstm">
                                                            <div className="desk usrDetailCstmLft"><img src={getUserProfileImg} /></div>
                                                            <div className='usrDetailCstmRght'>
                                                                {isNameLong ? (
                                                                    <Tooltip title={fullName}>
                                                                      <UserName>{fullName.slice(0, 12)}...</UserName>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <UserName>{fullName}</UserName>
                                                                )}
                                                               <UserDistrict>
                                                                {currentOrg?.displayName?.length > 20
                                                                    ? `${currentOrg.displayName.slice(0, 20)}..`
                                                                    : currentOrg?.displayName}
                                                                </UserDistrict>
                                                               <div className="setMenuArrow"><img src={profileArrow} /></div>
                                                            </div>
                                                        </div>
                                                    </UserDetails>
                                                    <UserDetailsMob laptop={laptop} className="usrDetail">
                                                        <div className="usrPic mob" style={{ marginLeft: 15 }}><img src={getUserProfileImg} /></div>
                                                    </UserDetailsMob>
                                                </UserContainer>
                                            </Dropdown>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                {!isTeacherHome && currentUser?.role !== 'parent' && (
                                                    <>
                                            
                                                        <MobileBar className="mobileBar">
                                                            <MobileMenu className="mobileMenuDrop">
                                                                <div onClick={() => showDrawerMenuBook()}>
                                                                    {/* <Dropdown> */}
                                                                    <ButtonLink onClick={e => e.preventDefault()} className='headerMenuIcon'>
                                                                        <MenuOutlined />
                                                                    </ButtonLink>
                                                                    {/* </Dropdown> */}
                                                                </div>
                                                            </MobileMenu>
                                                        </MobileBar>
                                                    </>
                                                )}
                                                <UserDetailsMobs className="usrDetail wrapper-header-profile-drawer-mobile" onClick={() => showDrawerBottom()}>
                                                    <div className="usrPic" style={{ marginLeft: 15 }}><img src={getUserProfileImg} /></div>
                                                </UserDetailsMobs>
                                            </div>
                                        </RowContainer>
                                    </Row>
                                </InnerContainer>
                            </MaxWidthContainer>
                        </TopBar>
                    </NavWrap>
                )}

                {/* New Design */}
                {(isTeacherHome && currentUser?.role !== 'parent') && (
                <div className='welComeOneWay'>
                    <h1><span>Welcome to</span> One Way Education</h1>
                    <img src={birdIconSvg} alt="" />
                </div>
                )}
                {/* End of Design */}

                {get(currentUser, 'role', '') === 'admin' || is_placement_admin_user ? <DistrictAdminMenu>{children}</DistrictAdminMenu> : null}
                {get(currentUser, 'role', '') === 'owe_admin' ? <AdminMenu>{children}</AdminMenu> : null}
                <ChildContainer>
                    {(get(currentUser, 'role', '') !== 'owe_admin' && get(currentUser, 'role', '') !== 'admin') && !is_placement_admin_user &&
                        <MaxWidthContainer className={`${location.pathname === "/exams" ? "examsMaxWidthContainer" : ""}`} informateBook={location.pathname === "/informateBook"} whatsNew={currentUrl === "/whats-new"} isStrategies={currentUrl === '/Strategies'} isGraphicOrganizers={currentUrl === "/graphic_organizers"} val={currentUrl === '/Strategies' || currentUrl === "/graphic_organizers" || currentUrl === "/story-levels" || currentUrl === "/whats-new" }>
                            {!isTeacherHome && <WheelCheckList currentClass={currentClass} />}
                            {!isTeacherHome && <TrafficModal currentClass={currentClass} sharableWidget={trafficWidgetData} />}
                            {!isTeacherHome && <WidgetsClock currentClass={currentClass} sharableWidget={sharableWidget} />}
                            {!isTeacherHome && <WidgetsImages currentClass={currentClass} sharableWidget={sharableWidget} />}
                            {!isTeacherHome && <WidgetsTimer currentClass={currentClass} sharableWidget={sharableWidget} />}
                            {!isTeacherHome && <WidgetsReminder currentClass={currentClass} sharableWidget={sharableWidget} />}
                            {!isTeacherHome && get(currentUser, 'role') !== 'teacher' && currentClass && currentUser && (
                                <ReminderStudentPopups classId={get(currentClass, 'id', '')} studentId={get(currentUser, 'id', '')} isStudentActive={isCurrentStudentActive} />
                            )}
                            {!isTeacherHome && <WidgetsStory currentClass={currentClass} sharableWidget={sharableWidget} />}
                            {!isTeacherHome && <WidgetsText currentClass={currentClass} sharableWidget={sharableWidget} />}
                            {!isTeacherHome && <WheelWidget currentClass={currentClass} />}
                            {!isTeacherHome && <WidgetsExpression currentClass={currentClass} sharableWidget={sharableWidget} />}
                            {!isTeacherHome && <CheckListModal currentClass={currentClass} />}
                                    {!isTeacherHome && (
                                <>
                                    {currentUser?.role === 'teacher' ?
                                    <ModalMenu type='widgetStation' currentClass={currentClass} sharableWidget={sharableWidget} /> 
                                    :
                                    <WidgetsStation currentClass={currentClass} sharableWidget={sharableWidget}  />
                                    }
                                </>
                            )}
                           {!isTeacherHome && (
                                <>
                                   {currentUser?.role === 'teacher' ?
                                      <ModalMenu type='widgetGroup' currentClass={currentClass} sharableWidget={sharableWidget} /> 
                                   : 
                                      <WidgetsGroup currentClass={currentClass} sharableWidget={sharableWidget} />
                                   }
                                </>
                                    )}
                            {!isTeacherHome && <PreviousFDWidgets currentClass={currentClass} />}
                            {!isTeacherHome && <ShareAssignmentWidget sharableWidget={sharableWidget} currentClass={currentClass} />}
                            {!isTeacherHome && <NoiseMeter currentClass={currentClass} />}
                            {!isTeacherHome && <SlideWidgetComponent currentClass={currentClass} sharableWidget={sharableWidget} />}
                            {children}
                        </MaxWidthContainer>
                        }
                </ChildContainer>

                
            </Container>

            <StyledDrawer
                title={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <img src={getUserProfileImg} className="bottomBtnIconss" style={{ height: 35, borderRadius: 20 }} onClick={() => {
                        showProfilePhotoViewer();
                        onCloseBottom();
                    }} />
                        <div><Tooltip title={`${currentUser?.firstName + ' ' + currentUser?.lastName}`}>
                            
                            <span className='mobileBottomDrawer' style={{ fontSize: 20 }}>  {`${(currentUser?.firstName + ' ' + currentUser?.lastName).slice(0, 25)}${(currentUser?.firstName + ' ' + currentUser?.lastName).length > 15 ? '...' : ''
                                }`}</span>
                    </Tooltip>
                        <div style={{ fontSize: 12 }}>{`${currentClass?.displayName || ''}`}</div>
                    </div>
                </div>}
                placement={'bottom'}
                width={500}
                onClose={onCloseBottom}
                open={openBottom}
                className={(currentUser?.role === 'student' || currentUser?.role === 'parent') ? 'BottomDrawerProfile BottomDrawerProfileStud' : 'BottomDrawerProfile'}
            >
                <Menu>
                    {/* <Menu.Item style={{ padding: '0px' }}>
                        <PaddedBtn className="bottomBtnMenu" onClick={() => {
                            showProfilePhotoViewer()
                            onCloseBottom();
                        }}> */}
                    {/* <VpnKeyIcon className="bottomBtnIconss" /> */}
                    {/* <img src={getUserProfileImg} className="bottomBtnIconss" style={{ height: 25, borderRadius: 20 }} />
                            Change Avatar
                        </PaddedBtn>
                    </Menu.Item> */}
                    {currentUser?.role !== 'student' && document.referrer !== `${window.location.origin}/global-admin-search` &&
                    document.referrer !== `${window.location.origin}/data-browsers?tab=parent` &&
                    document.referrer !== `${window.location.origin}/data-browsers?tab=see_teachers` &&
                    document.referrer !== `${window.location.origin}/data-browsers?tab=see_students` && (
                        <>
                            <Menu.Item style={{ padding: '0px' }}>
                                <PaddedBtn className="bottomBtnMenu" onClick={() => {
                                    navigate('/account')
                                    onCloseBottom();
                                }}>
                                    <VpnKey className="bottomBtnIconss" />
                                    Reset Password
                                </PaddedBtn>
                            </Menu.Item>
                            <Menu.Item style={{ padding: '0px' }}>
                                <PaddedBtn className="bottomBtnMenu" onClick={() => {
                                    viewInfoModalRef.current?.open();
                                    onCloseBottom();
                                }}>
                                    <VpnKey className="bottomBtnIconss" />
                                    User info
                                </PaddedBtn>
                            </Menu.Item>
                        </>
                    )}
                    {currentUser?.role == 'teacher' && currentUser?.demo !== true && (
                        <Menu.Item style={{ padding: '0px' }}>
                            <PaddedBtn className="bottomBtnMenu" onClick={() => {loginAsPlacementAdmin() }}>
                                <School className="bottomBtnIconss" />
                                Placement Exam
                            </PaddedBtn>
                        </Menu.Item>
                    )}
                    {currentUser?.role === 'teacher' && (<Menu.Item style={{ padding: '0px' }}>
                        <PaddedBtn className="bottomBtnMenu" onClick={() => {
                            navigate(currentUser?.role === "teacher" ? "/teacher/home" : "/student/home")
                            onCloseBottom();
                        }}>
                            <Group className="bottomBtnIconss" />
                            Manage classes
                        </PaddedBtn>
                    </Menu.Item>)}
                    <Menu.Item style={{ padding: '0px' }}>
                        <PaddedBtn className="bottomBtnMenu" disabled={isTeacherHome ? true:false} style={{ cursor: isTeacherHome ? 'not-allowed' : 'pointer' }} onClick={() => {
                            navigate('/whats-new');
                            onCloseBottom();
                        }}>
                            <Update className="bottomBtnIconss" />
                            What's New
                        </PaddedBtn>
                    </Menu.Item>
                    {currentUser?.role === 'teacher' && !isTeacherHome && (
                    <Menu.Item style={{ padding: '0px' }}>
                        <PaddedBtn className="bottomBtnMenu" disabled={isTeacherHome ? true:false} style={{ cursor: isTeacherHome ? 'not-allowed' : 'pointer' }} onClick={() => {
                            setPermissionsModalOpen(true)
                            onCloseBottom();
                        }}>
                            <Security className="bottomBtnIconss" />
                            Permissions
                        </PaddedBtn>
                    </Menu.Item>
                    )}
                    {currentUser?.role === 'student' && userClasses?.length > 1 && (<Menu.Item style={{ padding: '0px' }}>
                        <PaddedBtn className="bottomBtnMenu" onClick={() => {
                            navigate(currentUser?.role === "teacher" ? "/teacher/home" : "/student/home")
                            onCloseBottom();
                        }}>
                            <Class className="bottomBtnIconss" />
                            Manage classes
                        </PaddedBtn>
                    </Menu.Item>)}
                   {currentUser?.role === 'teacher' && <Menu.Item style={{ padding: '0px' }}>
                        <PaddedBtn className="bottomBtnMenu" onClick={() => {
                            invokeFeedback();
                            onCloseBottom();
                        }}>
                            <Report className="bottomBtnIconss" />
                            Report an issue
                        </PaddedBtn>
                    </Menu.Item>}
                    <Menu.Item style={{ padding: '0px' }}>
                        <PaddedBtn className="bottomBtnMenu" onClick={() => {
                            checkAndRefreshLatestCode();
                            onCloseBottom();
                        }}>
                            <Update className="bottomBtnIconss" />
                            Refresh
                        </PaddedBtn>
                    </Menu.Item>
                    <Menu.Item disabled={timmerRunning} style={{ padding: '0px' }}>
                        <PaddedBtn className="bottomBtnMenu" onClick={() => {
                            onLogOutPress();
                            onCloseBottom();
                        }}>
                            <Logout className="bottomBtnIconss" />
                            Logout
                        </PaddedBtn>
                    </Menu.Item>
                </Menu>
            </StyledDrawer>


            <StyledDrawer
                title={`Menu`}
                placement={'right'}
                onClose={onCloseMenuBook}
                open={openMenuBook}
                className={`HeaderMenuMObile ${openMenuClass ? 'drawer-shifted' : ''}`}
                forceRender
                    >
                         <div className="main-wrapper-class">
                        <Navigation className="mobileMenu">
                            {userClasses?.length > 1 && !isDirector && !isTeacherHome ? (
                                <>
                                    {/* {currentUser?.role === "teacher" ||  && ( */}
                                        <NavigationItem laptop={laptop}>
                                        <TopDrawers setOpenMenuClass={setOpenMenuClass} openMenuClass={openMenuClass} onOpenDrawer={() => {
                                            setOpenMenuClass(true);
                                            // onCloseMenuBook()
                                        }} children={<ButtonLink 
                                                laptop={laptop}
                                                to="desktop"
                                            >
                                                CLASSES
                                                <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                            </ButtonLink>} />
                                        </NavigationItem>
                                    {/* )} */}
                                </>
                            ) : (
                        <NavigationItem>
                            <ButtonLink onClick={() => {
                                getRoute()
                                onCloseMenuBook()
                            }}>
                                Home
                            </ButtonLink>
                        </NavigationItem>
                    )}
                    {!isTeacherHome && currentUser?.role !== 'parent' && <NavigationItem>
                        <Dropdown
                            menu={eBookNav()}
                            placement="bottomLeft"
                            trigger={['click']}
                            getPopupContainer={(trigger) => trigger.parentNode}
                            overlayClassName="optionsListMenu ebookNavDropdown"
                        >
                            <ButtonLink onClick={e => e.preventDefault()}>
                                EBook
                                <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                            </ButtonLink>
                        </Dropdown>
                    </NavigationItem>}
                    {(currentUser?.role === 'student' || currentUser?.role === 'teacher' || currentUser?.role === 'admin') && get(orgPermissions, '1nformate', true) && (
                        <NavigationItem>
                            <Dropdown menu={informateNav()} placement="bottomLeft" trigger={['click']} getPopupContainer={(trigger) => trigger.parentNode}>
                                <ButtonLink onClick={e => e.preventDefault()}>
                                    1nformate
                                    <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                </ButtonLink>
                            </Dropdown>
                        </NavigationItem>
                    )}
                    {get(orgPermissions, '1WAYRESOURCES', true) && currentUser?.role !== 'parent' && <NavigationItem>
                        <ButtonLink onClick={() => {
                            resources()
                            onCloseMenuBook()
                        }}>
                            1WAYRESOURCES
                        </ButtonLink>
                    </NavigationItem>}
                    {currentUser?.role === 'owe_admin' && (
                        <>
                            <NavigationItem>
                                <ButtonLink onClick={logs}>
                                    Logs
                                </ButtonLink>
                            </NavigationItem>
                        </>
                    )}
                    {currentUser?.role === 'owe_admin' && (
                        <>
                            <NavigationItem>
                                <ButtonLink onClick={() => {
                                    schoologyLink()
                                    onCloseMenuBook()
                                }}>
                                    Schoology
                                </ButtonLink>
                            </NavigationItem>
                        </>
                    )}
                    {currentUser?.role === 'owe_admin' && (
                        <>
                            <NavigationItem>
                                <ButtonLink onClick={() => {
                                    classlinkLink()
                                    onCloseMenuBook()
                                }}>
                                    Classlink
                                </ButtonLink>
                            </NavigationItem>
                        </>
                    )}
                    {currentUser?.role === 'owe_admin' && (
                        <>
                            <NavigationItem>
                                <ButtonLink onClick={() => {
                                    cleverLink()
                                    onCloseMenuBook()
                                }}>
                                    Clever
                                </ButtonLink>
                            </NavigationItem>
                        </>
                    )}



                    {(currentUser?.role === 'student' || currentUser?.role === 'teacher') && !isTeacherHome && (
                        <NavigationItem desktop>
                            <ButtonLink onClick={() => {
                                onWayLessons()
                                onCloseMenuBook()
                            }}>
                                1waylessons
                            </ButtonLink>
                        </NavigationItem>
                    )}
                    {/* Story level for student */}
                    {(currentUser?.role === 'student') && get(orgPermissions, '1WAYSTORY', true) && !isTeacherHome && (
                        <NavigationItem desktop>
                            <ButtonLink onClick={() => {
                                onStorylevel()
                                onCloseMenuBook()
                            }}>
                                1WayStory
                            </ButtonLink>
                        </NavigationItem>
                    )}
                    {/* Story level for teacher */}
                    {(currentUser?.role === 'teacher' || currentUser?.role === 'admin') && get(orgPermissions, '1WAYSTORY', true) && !isTeacherHome && (
                        <NavigationItem desktop>
                            <Dropdown menu={storyNav()} placement="bottomLeft" trigger={['click']} getPopupContainer={(trigger) => trigger.parentNode}>
                                <ButtonLink onClick={e => {
                                    e.preventDefault()
                                }}>
                                    1WayStory
                                    <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                </ButtonLink>
                            </Dropdown>
                        </NavigationItem>
                    )}
                    {(currentUser?.role === 'teacher') && get(orgPermissions, '1WAYTEACHER', true) && !isTeacherHome && (
                        <NavigationItem desktop>
                            <Dropdown menu={resourceNav()} placement="bottomLeft" trigger={['click']} getPopupContainer={(trigger) => trigger.parentNode}>
                                <ButtonLink onClick={e => {
                                    e.preventDefault()
                                }}   >
                                    1WAYTEACHER
                                    <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                </ButtonLink>
                            </Dropdown>
                        </NavigationItem>
                    )}
                    {(currentUser?.role === 'student') && get(orgPermissions, '1WAYTEACHER', true) && !isTeacherHome && (
                        <NavigationItem>
                            <ButtonLink onClick={() => {
                                onWayTeacher()
                                onCloseMenuBook()
                            }}>
                                1WAYSTUDENT
                            </ButtonLink>
                        </NavigationItem>
                    )}
                    {(currentUser?.role === 'student' || currentUser?.role === 'teacher' || currentUser?.role === 'admin') && !isTeacherHome && get(orgPermissions, 'ap', true) && (
                        <NavigationItem desktop>
                            <Dropdown menu={apNav()} placement="bottomLeft" trigger={['click']} getPopupContainer={(trigger) => trigger.parentNode}>
                                <ButtonLink onClick={e => { e.preventDefault() }
                                }>
                                    AP
                                    <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                </ButtonLink>
                            </Dropdown>
                        </NavigationItem>
                    )}
                    {/* {currentUser?.role === 'teacher' && currentUser?.demo && (
                        <NavigationItem >
                            <ButtonLink onClick={() => {
                                pd()
                                onCloseMenuBook()
                            }}>
                                PD
                            </ButtonLink>
                        </NavigationItem>
                    )} */}

                    {currentUser?.role === "teacher" && (
                        <>
                            <NavigationItem>
                                <ButtonLink onClick={() => {
                                    navigate("/admin/class?view=manage")
                                    onCloseMenuBook()
                                }}>
                                    Assignments
                                </ButtonLink>
                            </NavigationItem>
                            <NavigationItem >
                                <ButtonLink onClick={() => {
                                    navigate("/admin/class?view=gradebook")
                                    onCloseMenuBook()
                                }}>
                                    Gradebook
                                </ButtonLink>
                            </NavigationItem>
                            <NavigationItem >
                                <ButtonLink onClick={() => {
                                    navigate("/admin/class?view=classdata")
                                    onCloseMenuBook()
                                }}>
                                    Class Data
                                </ButtonLink>
                            </NavigationItem>
                            {/* <NavigationItem>
                                    <ButtonLink onClick={() => {
                                        setIdeasModal(true);
                                        // navigate("/admin/class?view=manage")
                                        onCloseMenuBook()
                                    }}>
                                        idea with1WAY
                                    </ButtonLink>
                                </NavigationItem> */}
                        </>
                    )}
                    {(currentUser?.role === "teacher" || currentUser?.role === "student") && (
                        <NavigationItem>
                            <ButtonLink onClick={() => {
                                setDebatesModal(true)
                                onCloseMenuBook()
                            }}>
                                1Debate!
                            </ButtonLink>
                        </NavigationItem>
                    )}
                    {(currentUser?.role === "student") && (
                        <NavigationItem>
                            <ButtonLink onClick={() => {
                                setOneGameModalVisible(true)
                                onCloseMenuBook()
                            }}>
                                1Game!
                            </ButtonLink>
                        </NavigationItem>
                    )}
                    {(currentUser?.role === 'student' || currentUser?.role === 'teacher' || currentUser?.role === 'admin') && get(orgPermissions, 'exams', true) && (
                        <NavigationItem desktop>
                            <Dropdown menu={examsNav()} placement="bottomLeft" trigger={['click']} getPopupContainer={(trigger) => trigger.parentNode}>
                                <ButtonLink onClick={e => {
                                    e.preventDefault()
                                }}   >
                                    EXAMS
                                    <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                </ButtonLink>
                            </Dropdown>
                        </NavigationItem>
                    )}
                    {currentUser?.role === "student" && (
                        <NavigationItem>
                             <ButtonLink onClick={() => {
                                setBingoModals(true)
                                onCloseMenuBook()
                            }}>
                                Loteria
                            </ButtonLink>
                        </NavigationItem>
                    )}

                {isFrame &&  (
                        <NavigationItem>
                            <ButtonLink onClick={() => {
                                if (location.pathname === '/chat') {
                                    navigate(-1);
                                } else {
                                    navigate('/chat');
                                }
                            }}>
                                CHAT
                            </ButtonLink>
                        </NavigationItem>
                    )}

                    
                    {isFrame &&  (
                        <>
                        <div style={{ display: 'none' }}><IdeaModal ideasModal={ideasModal} setIdeasModal={setIdeasModal} /></div>
                                <NavigationItem>
                                <ButtonLink onClick={() => {
                                setIdeasModal(true)
                                }}>
                                    1wayIdea
                                </ButtonLink>
                            </NavigationItem>
                        </>
                    )}
                </Navigation>
                </div>
            </StyledDrawer>
            <div style={{ display: 'none' }}>
                {/* <IdeaModal ideasModal={ideasModal} setIdeasModal={setIdeasModal} /> */}
                <WheelModal wheelsModal={wheelsModal} setWheelsModal={setWheelsModal} />
                <DebateModal debatesModal={debatesModal} setDebatesModal={setDebatesModal} />
                <OneGameJoinModalButton oneGameModalVisible={oneGameModalVisible} setOneGameModalVisible={setOneGameModalVisible}/>
                {currentUser?.role === "student" && (
                    <BingoModal bingoModals={bingoModals} setBingoModals={setBingoModals}/>
                )}
            </div>
            <ViewUserInfoModal ref={viewInfoModalRef} />
        </div>
        <Chat showIcon={false} />
        </>
    )}
</SentryWrap>
    );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({
    currentOrg: state.currentOrg,
    currentUser: state.currentUser,
    userClasses: state.userClasses,
    booksAllList: state.booksAllList,
    currentClass: state.currentClass,
});

export default connect(mapStateToProps, null)(Wrapper);
